<template>
  <section>
    <notifications></notifications>

    <base-header>
      <div class="row align-items-center pt-header">
        <div
          class="col-xl-5 col-lg-5 col-md-6 col-sm-4 col-12 align-items-center"
        >
          <div class="d-flex align-items-center">
            <div>
              <el-tooltip content="Back" placement="bottom">
                <base-button
                  type="neutral"
                  class="btn-icon-only"
                  @click="goToPreviousPage()"
                >
                  <i class="flaticon-left-1"></i>
                </base-button>
              </el-tooltip>
            </div>

            <div>
              <h1 class="title-view">Reservation</h1>

              <div class="box-id">
                <span class="number-id"> {{ booking_number }} </span>
                <span class="ml-2 mr-2" v-if="reservationStatus">|</span>
                <div class="status-tab" v-if="reservationStatus">
                  <div
                    class="badge-status text-status"
                    v-bind:class="
                      getStatusClass(
                        reservationStatus,
                        statusUpdate,
                        owner,
                        pickupDate,
                        timezone
                      )
                    "
                  >
                    {{ getLabelStatus(reservationStatus, statusUpdate) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="col-xl-7 col-lg-7 col-md-6 col-sm-8 col-12 align-items-center alinmov2"
        >
          <div class="box-buttons">
            <base-dropdown
              v-if="
                !['SBC', 'SCB', 'JF', 'SC'].includes(reservationStatus) &&
                  owner === 'admin'
              "
              menu-on-left
              class="nav-item"
              tag="li"
              title-tag="a"
              title-classes="btn min-button btn-outline-neutral ml-2"
              title="Actions"
            >
              <base-button slot="title" type="none" class="p-0 min-button">
                <i class="flaticon-bold-menu-1"></i>
                <strong class="d-lg-block d-none">Actions</strong>
              </base-button>

              <div
                class="dropdown-item"
                @click="
                  openReservationHistoryModal(reservationId, booking_number)
                "
              >
                <span class="icon-action">
                  <i class="flaticon-wall-clock-1 text-blue"></i>
                  View History
                </span>
              </div>

              <div
                class="dropdown-item"
                v-if="canConfirmBooking(reservationStatus, statusUpdate, owner)"
                @click.stop="
                  confirmBooking(reservationId, confirmReservationById)
                "
              >
                <span class="icon-action">
                  <i class="flaticon-bold-check-3 text-success"> </i>
                  Confirm
                </span>
              </div>

              <div
                class="dropdown-item"
                v-if="canCancelBooking(reservationStatus, owner)"
                @click.stop="cancelBooking(reservationId, cancelBookingById)"
              >
                <span class="icon-action">
                  <i class="flaticon-remove text-cancelled"></i> Cancel
                </span>
              </div>
              <div
                class="dropdown-item"
                v-if="
                  canCompleteBooking(reservationStatus) &&
                    calculateHoursDifference(
                      reservation.pickup_date,
                      timezone
                    ) >= 12
                "
                @click.stop="
                  completeBooking(reservationId, changeBookingStatus)
                "
              >
                <span class="icon-action">
                  <i class="flaticon-check text-completed"></i> Complete
                </span>
              </div>
              <div
                class="dropdown-item"
                v-if="
                  canMarkBookingAsNoShow(reservationStatus) &&
                    calculateHoursDifference(
                      reservation.pickup_date,
                      timezone
                    ) >= 12
                "
                @click.stop="noShowBooking(reservationId, changeBookingStatus)"
              >
                <span class="icon-action">
                  <i class="flaticon-no-group text-no-show"></i> No Show
                </span>
              </div>

              <div
                class="dropdown-divider"
                v-if="canResendBookingEmail(reservationStatus, owner)"
              ></div>

              <div
                class="dropdown-item"
                v-if="canResendBookingEmail(reservationStatus, owner)"
                @click="
                  resendBookingNotifications(
                    reservationId,
                    handleResendBookingNotifications
                  )
                "
              >
                <span class="icon-action">
                  <i class="flaticon-envelope text-orange"></i> Resend Email
                </span>
              </div>
            </base-dropdown>

            <base-dropdown
              menu-on-right
              class="nav-item"
              tag="li"
              title-tag="a"
              title-classes="btn min-button btn-outline-neutral ml-2"
              title="Actions"
              v-if="mode === 'edit'"
            >
              <base-button slot="title" type="none" class="p-0 min-button">
                <i class="flaticon-plus"></i>
                <strong class="d-lg-block d-none">Add</strong>
              </base-button>
              <div class="dropdown-item" @click="openExtrasModal()">
                <span class="icon-action"> Add Extras </span>
              </div>

              <div class="dropdown-item" @click="openDiscountModal()">
                <span class="icon-action"> Add Discount </span>
              </div>
            </base-dropdown>

            <base-button
              type="outline-neutral"
              @click="mode = 'view'"
              class="min-button ml-2 no-mb"
              v-if="mode === 'edit'"
            >
              <i class="flaticon-view-1 icon-no-margin"></i>
              <strong class="d-lg-block d-none">View</strong>
            </base-button>

            <base-button
              type="outline-neutral"
              @click="mode = 'edit'"
              class="min-button ml-2 no-mb"
              v-if="mode === 'view' && reservationOwner === 'rhomtrip-supplier'"
            >
              <i class="flaticon-pencil icon-no-margin"></i>
              <strong class="d-lg-block d-none">Edit</strong>
            </base-button>

            <base-button
              type="primary"
              @click="storeReservation()"
              class="min-button ml-2 no-mb"
              v-if="mode === 'edit' || reservationOwner === 'rhomtrip'"
            >
              <i class="flaticon-floppy-disk icon-no-margin"></i>
              <strong class="d-lg-block d-none">Save</strong>
            </base-button>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mb-5">
      <div class="row">
        <div
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-2"
          v-if="
            reservation.childSeatsCount > 0 &&
              reservationOwner === 'rhomtrip' &&
              reservationStatus === 'NW'
          "
        >
          <base-alert type="warning" class="mb-2 info-min">
            <i class="flaticon-warning mr-1"></i>

            <strong>Important!</strong>

            <ol class="pl-3 mb-0">
              <li
                v-if="
                  reservation.childSeatsCount > 0 &&
                    reservationOwner === 'rhomtrip'
                "
              >
                <span class="span-alert">
                  <strong>
                    This reservation includes a request for a child seat(s).
                  </strong>
                  Please confirm the availability of the requested child seat(s)
                  and indicate if there are any additional charges. By accepting
                  this reservation, you confirm that you can provide the
                  requested number of child seats. If they are unavailable,
                  please reject the booking or contact our customer support team
                  for assistance.
                </span>
              </li>
            </ol>
          </base-alert>
        </div>

        <div v-if="mode === 'view'" class="forms ticket">
          <div class="col-12">
            <div class="row">
              <div class="col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                <div class="row">
                  <div class="col-xl-12 col-lg-12 box-ticket">
                    <div class="row">
                      <div class="col-xl-12">
                        <div class="header-ticket">
                          <div class="row">
                            <div
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 alinmov1 align-self-center"
                            >
                              <span class="capitalize title-passenger">
                                {{ getTitleByGender(passenger.gender) }}
                                {{ passenger.firstName }}
                                {{ passenger.lastName }}
                              </span>

                              <span class="date-time">
                                {{
                                  formatPickupDate(
                                    reservation.pickup_date,
                                    formatDate
                                  )
                                }}
                                at
                                {{
                                  formatPickupTime(
                                    reservation.pickup_time,
                                    formatTime
                                  )
                                }}
                              </span>
                            </div>

                            <div
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 alinmov2 mt-sm-0 mt-3 align-self-center"
                            >
                              <span class="label-total"> TOTAL CHARGES: </span>
                              <span
                                v-if="display !== 'net_price'"
                                class="price-total"
                                :class="
                                  reservation.pricing.totals.gross_price < 0
                                    ? 'loss-alert'
                                    : ''
                                "
                              >
                                {{ currency.symbol }}
                                {{
                                  normalizePriceAmount(
                                    reservation.pricing.totals.gross_price
                                  )
                                }}
                                {{ currency.code }}
                              </span>
                              <span
                                v-else
                                class="price-total"
                                :class="
                                  reservation.pricing.totals.net_price < 0
                                    ? 'loss-alert'
                                    : ''
                                "
                              >
                                {{ currency.symbol }}
                                {{
                                  normalizePriceAmount(
                                    reservation.pricing.totals.net_price
                                  )
                                }}
                                {{ currency.code }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-xl-12 col-lg-12">
                        <div class="card-ticket">
                          <div class="box">
                            <div class="row">
                              <div class="col-12 p-0">
                                <div class="col-12 mt-lg-0 mt-md-3 mt-sm-3">
                                  <div class="address-content">
                                    <div class="icon-pick">
                                      <i
                                        class="flaticon-start text-primary"
                                      ></i>
                                    </div>

                                    <div class="content">
                                      <span class="title-one"
                                        >Pickup:
                                        {{
                                          formatPickupTime(
                                            reservation.pickup_time,
                                            formatTime
                                          )
                                        }}
                                      </span>
                                      <span class="title-two">
                                        {{ reservation.from }}
                                      </span>
                                    </div>
                                  </div>

                                  <div
                                    class="address-content mt-2"
                                    v-if="reservation.type !== 'hourly'"
                                  >
                                    <div class="icon-pick">
                                      <i
                                        class="flaticon-placeholder-1 text-success"
                                      ></i>
                                    </div>

                                    <div class="content">
                                      <span class="title-one">Dropoff </span>
                                      <span class="title-two">{{
                                        reservation.to
                                      }}</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="box box-services">
                            <div class="row" v-if="service">
                              <div
                                class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                              >
                                <div class="row card-serv-v card-select">
                                  <div
                                    class="col-xl-2 col-md-2 col-sm-3 col-12 align-self-center alinmov4"
                                  >
                                    <img
                                      v-lazy="service.vehicle.image"
                                      class="img-fluid es-img-service"
                                      alt="Service Car"
                                    />
                                  </div>
                                  <div
                                    class="col-xl-4 col-lg-4 col-md-4 col-sm-9 col-12 align-self-center alinmov4 pl-sm-0 pr-0 bord-left"
                                  >
                                    <h2 class="title-serv">
                                      {{
                                        formatVehicleCategory(
                                          service.vehicle.category
                                        )
                                      }}

                                      {{ service.vehicle.seats }} seats
                                    </h2>

                                    <span class="type-card"
                                      >{{ service.vehicle.make_label }} or
                                      Similar</span
                                    >

                                    <div class="descrip">
                                      <span>
                                        <i class="flaticon-people-1"></i>
                                        PAX:
                                        {{ service.vehicle.seats }}
                                      </span>

                                      <span>
                                        <i class="flaticon-briefcase"></i>
                                        Bags: {{ service.vehicle.suitcases }}
                                      </span>
                                    </div>

                                    <div class="more-details">
                                      <ul class="mb-0">
                                        <li
                                          v-for="tag in service.vehicle.tags || []"
                                          :key="tag.ref"
                                        >
                                          {{ tag.name }}
                                        </li>
                                        <li v-if="service.preference.wifi">
                                          WiFi onboard
                                        </li>
                                        <li v-if="service.preference.water">
                                          Water
                                        </li>
                                        <li
                                          v-if="
                                            service.preference.hand_sanitizer
                                          "
                                        >
                                          Hand Sanitizer
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                  <div
                                    class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 alinmov8 align-self-center pl-lg-0"
                                  >
                                    <div class="box-driver" v-if="driver">
                                      <div class="text-center">
                                        <label class="title-box"
                                          >Driver Information
                                        </label>
                                      </div>
                                      <div class="card-driver">
                                        <div class="content-image">
                                          <div
                                            class="img-driver"
                                            v-bind:style="{
                                              backgroundImage: driver.profile
                                                .image
                                                ? `url('${driver.profile.image}')`
                                                : 'url(' + imageProfile + ')'
                                            }"
                                          ></div>
                                        </div>

                                        <div class="content">
                                          <div class="item-content">
                                            <label>Driver: </label>
                                            <span
                                              >{{
                                                getTitleByGender(
                                                  driver.person.gender
                                                )
                                              }}
                                              {{ driver.person.first_name }}
                                              {{
                                                driver.person.last_name
                                              }}</span
                                            >
                                          </div>
                                          <div
                                            class="item-content"
                                            :class="{
                                              'mb-0': !driver.person
                                                .numbre_phone
                                            }"
                                          >
                                            <label>Phone: </label
                                            ><span
                                              ><a
                                                :href="
                                                  `tel:${driver.person.numbre_phone}`
                                                "
                                                >{{
                                                  driver.person.numbre_phone
                                                }}</a
                                              >
                                              <el-tooltip
                                                content="Copy"
                                                placement="bottom"
                                              >
                                                <span
                                                  class="curp ml-2"
                                                  v-clipboard:copy="
                                                    driver.person.numbre_phone
                                                  "
                                                  v-clipboard:success="onCopy"
                                                  v-clipboard:error="
                                                    onErrorCopy
                                                  "
                                                >
                                                  <i
                                                    class="flaticon-copy link ml-0"
                                                  ></i></span></el-tooltip
                                            ></span>
                                          </div>

                                          <div
                                            class="item-content"
                                            :class="{
                                              'mb-0': !driver.account.email
                                            }"
                                            v-if="driver.account.email"
                                          >
                                            <label>Email: </label>
                                            <span
                                              ><a
                                                :href="
                                                  `https://mail.google.com/mail/?view=cm&fs=1&to=${driver.account.email}`
                                                "
                                                >{{ driver.account.email }}</a
                                              >
                                              <el-tooltip
                                                content="Copy"
                                                placement="bottom"
                                              >
                                                <span
                                                  class="curp ml-2"
                                                  v-clipboard:copy="
                                                    driver.account.email
                                                  "
                                                  v-clipboard:success="onCopy"
                                                  v-clipboard:error="
                                                    onErrorCopy
                                                  "
                                                >
                                                  <i
                                                    class="flaticon-copy link ml-0"
                                                  ></i>
                                                </span>
                                              </el-tooltip>
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div class="box-driver" v-else>
                                      <div class="text-center">
                                        <label class="title-box"
                                          >Driver Information
                                        </label>
                                      </div>

                                      <base-alert
                                        type="warning"
                                        class="info-min text-center"
                                      >
                                        <i class="flaticon-warning mr-1"></i>
                                        <strong>No driver assigned!</strong>
                                        Wait for driver assignment
                                      </base-alert>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="box">
                            <div class="row">
                              <div
                                class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12"
                              >
                                <div class="data-block">
                                  <span class="title-block">Type Transfer</span>
                                  <span class="content-block">
                                    {{ formatBookingType(reservation.type) }}
                                  </span>
                                </div>
                              </div>

                              <div
                                class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12"
                              >
                                <div class="data-block">
                                  <span class="title-block">PAX N°</span>
                                  <span class="content-block"
                                    >{{ reservation.passengersCount }} PAX</span
                                  >
                                </div>
                              </div>

                              <div
                                class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12"
                              >
                                <div class="data-block">
                                  <span class="title-block">PAX</span>
                                  <span class="content-block">
                                    {{ getTitleByGender(passenger.gender) }}
                                    {{ passenger.fullName }}</span
                                  >
                                </div>
                              </div>

                              <div
                                class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12"
                              >
                                <div class="data-block">
                                  <span class="title-block"
                                    >Contact Number</span
                                  >
                                  <span class="content-block"
                                    >{{ passenger.phone }}
                                    <el-tooltip
                                      content="Copy"
                                      placement="bottom"
                                    >
                                      <span
                                        class="curp ml-2"
                                        v-clipboard:copy="passenger.phone"
                                        v-clipboard:success="onCopy"
                                        v-clipboard:error="onErrorCopy"
                                      >
                                        <i
                                          class="flaticon-copy link ml-0"
                                        ></i></span></el-tooltip
                                  ></span>
                                </div>
                              </div>

                              <div
                                :class="{
                                  'col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12':
                                    reservation.flight_number,
                                  'col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12': !reservation.flight_number
                                }"
                                v-if="!disabledElement(owner)"
                              >
                                <div class="data-block" v-if="customer">
                                  <span class="title-block">Customer</span>
                                  <span class="content-block">
                                    <a
                                      class="capitalize"
                                      :href="
                                        [
                                          'travel_agency',
                                          'travel_access'
                                        ].includes(customer.type)
                                          ? `/partners/profile/${customer._id}`
                                          : `/customers/${customer._id}`
                                      "
                                      target="_blank"
                                      >{{ customer.first_name }}
                                      {{ customer.last_name }}
                                    </a>
                                    <span class="type-card">
                                      -
                                      {{
                                        parseCustomerType(customer.type)
                                      }}</span
                                    >
                                  </span>
                                </div>
                              </div>

                              <div
                                class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12"
                                v-if="reservation.type != 'journey'"
                              >
                                <div class="data-block">
                                  <span class="title-block">
                                    {{ getLabelTransport(reservation.type) }}
                                  </span>
                                  <span
                                    class="content-block"
                                    :class="{
                                      'text-link':
                                        isFlightType &&
                                        reservation.flight_number,
                                      uppercase:
                                        reservation.type !== 'hourly' &&
                                        getTransportReference(reservation)
                                    }"
                                    @click="
                                      getFlightsInformationByIdent(
                                        reservation.flight_number
                                      )
                                    "
                                  >
                                    {{
                                      getTransportReference(reservation) ||
                                        "Not included"
                                    }}
                                    <i
                                      v-if="
                                        isFlightType &&
                                          reservation.flight_number
                                      "
                                      class="flaticon-link"
                                    ></i
                                  ></span>

                                  <base-alert
                                    type="info"
                                    class="mb-0"
                                    v-if="loaderVerifyFlight"
                                  >
                                    <div class="d-flex align-items-center">
                                      <img
                                        src="~rhomtrip_assets/src/img/icons/loaders/loader-1.gif"
                                        alt="loader"
                                        class="d-inline mr-2"
                                      />
                                      <span class="d-inline info-min"
                                        ><strong class="d-block"
                                          >Verifying flight... </strong
                                        >Redirecting to flight tracking
                                        page…</span
                                      >
                                    </div>
                                  </base-alert>
                                </div>
                              </div>

                              <div
                                class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                                v-if="reservation.flight_number && flight"
                              >
                                <FlightDetails mode="view" :flight="flight" />
                              </div>

                              <div
                                class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12"
                              >
                                <div class="data-block">
                                  <span class="title-block">Pickup Sign</span>
                                  <div v-if="pdfDataUrl" class="content-block">
                                    <span
                                      class="link ml-0"
                                      @click="openPreviewPickup()"
                                    >
                                      <i class="flaticon-visualization mr-1"></i
                                      >File uploaded</span
                                    >
                                  </div>

                                  <div v-else>
                                    <span
                                      class="content-block"
                                      v-if="reservation.pickupSign.text"
                                      >{{ reservation.pickupSign.text }}</span
                                    >

                                    <span class="content-block" v-else
                                      >NONE</span
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        class="col-12 mt-2"
                        v-if="
                          reservation.childSeatsCount > 0 ||
                            reservation.special_requirements
                        "
                      >
                        <div class="card pb-2 mb-0">
                          <div class="data-block mb-2">
                            <span class="title-block f-14">Extras</span>
                          </div>

                          <div class="row">
                            <div
                              class="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12"
                              v-if="reservation.special_requirements"
                            >
                              <div class="data-block">
                                <span class="title-block"
                                  >Special Requirements</span
                                >
                                <span class="content-block">{{
                                  reservation.special_requirements
                                }}</span>
                              </div>
                            </div>

                            <div
                              class="col-xl-4 col-lg-4 col-md-8 col-sm-12 col-12"
                              v-if="reservation.childSeatsCount > 0"
                            >
                              <div class="data-block">
                                <span class="title-block">Child Seats N°</span>
                                <span class="content-block"
                                  >{{ reservation.childSeatsCount }} Seats</span
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        class="col-xl-12 col-12 mt-2"
                        v-if="
                          reservationOwner === 'rhomtrip' &&
                            reservation.passengers.length > 1
                        "
                      >
                        <div class="card mb-0">
                          <div class="data-block mb-2">
                            <span class="title-block f-14">PAX</span>
                          </div>
                          <div>
                            <b-table
                              hover
                              :items="reservation.passengers"
                              :fields="
                                getHeaderPassengerTable(
                                  fieldsPassengerView,
                                  reservation.type
                                )
                              "
                              sort-by.sync="fullname"
                              sort-desc.sync="true"
                              select-mode="single"
                              ref="tableviewpassengers"
                              sort-icon-left
                              responsive
                              show-empty
                              empty-filtered-text="There are no records here"
                              empty-text="There are no records to show"
                            >
                              <template #cell(fullname)="data">
                                <span class="text-capitalize"
                                  >{{ getTitleByGender(data.item.gender) }}
                                  {{ data.item.firstName }}
                                  {{ data.item.lastName }}
                                </span>

                                <span
                                  class="badge-status badge-default mr-2"
                                  v-if="data.item.primary"
                                  >Primary</span
                                >
                              </template>

                              <template #cell(phone)="data">
                                <span v-if="data.item.phone">
                                  <a
                                    :href="`tel:${data.item.phone}`"
                                    target="blank"
                                  >
                                    {{ data.item.phone }}</a
                                  >
                                </span>
                                <span v-else>N/A</span>
                              </template>

                              <template #cell(email)="data">
                                <span v-if="data.item.email">
                                  <a :href="`mailto:${data.item.email}`">{{
                                    data.item.email
                                  }}</a>
                                </span>
                                <span v-else> N/A</span>
                              </template>

                              <template #cell(itinerary)="data">
                                <span
                                  class="uppercase"
                                  v-if="data.item.flightNumber"
                                  >{{ data.item.flightNumber }}</span
                                >
                                <span v-else>N/A</span>
                              </template>

                              <template #cell(type)="data">
                                {{ getPassengerType(data.item.type) }}
                              </template>
                            </b-table>
                          </div>
                        </div>
                      </div>

                      <!-- Driver -->
                      <div
                        class="col-xl-12 mt-2"
                        v-if="reservationOwner === 'rhomtrip'"
                      >
                        <div class="card mb-0">
                          <h2 class="subtitle mb-3">Driver</h2>
                          <div class="row">
                            <div
                              class="col-xl-4 col-lg-8 col-md-9 col-sm-8 col-9 no-margin mb-4"
                            >
                              <WSelect
                                placeholder="Select Driver"
                                id="driver"
                                v-model="driverId"
                                @change="changeDriver"
                                name="driver"
                                indexTab="13"
                                clearable
                                filterable
                                :disabled="
                                  disabledDriver(
                                    reservationStatus,
                                    reservation.driver
                                  )
                                "
                                label="Driver Assigned"
                              >
                                <el-option
                                  v-for="(item, index) in driversOptions"
                                  :value="item._id"
                                  :label="
                                    `${item.person.first_name} ${item.person.last_name}`
                                  "
                                  :key="index"
                                ></el-option>
                              </WSelect>
                            </div>

                            <div
                              class="col-xl-4 col-lg-4 col-md-3 col-sm-4 col-3"
                            >
                              <base-button
                                @click="showAddModalDriver = true"
                                class="min-button"
                                type="outline-neutral"
                              >
                                <span class="d-sm-inline-block d-none">
                                  Add New</span
                                >
                                <span class="d-sm-none d-inline-block">
                                  Add</span
                                >
                              </base-button>
                            </div>
                          </div>
                          <AddDrivers
                            :show="showAddModalDriver"
                            :branchId="reservation.branch"
                            @close="closeNewDriverModal"
                            @input="addDriversInOptions"
                          />
                        </div>
                      </div>

                      <div
                        class="col-12 mt-2"
                        v-if="service && service.keyDetails"
                      >
                        <div class="card pb-3 mb-0">
                          <div class="data-block mb-2">
                            <span class="title-block f-14">Key Details</span>
                            <span class="content-block">
                              {{ service.keyDetails }}</span
                            >
                          </div>
                        </div>
                      </div>

                      <div class="col-12 mt-2" v-if="service">
                        <div class="card pb-3 mb-0">
                          <div class="data-block mb-2">
                            <span class="title-block f-14"
                              >Cancellations Policies</span
                            >
                          </div>

                          <ul class="cancellations-list">
                            <li
                              v-for="(item,
                              index) in service.cancellationPolicy"
                              :key="`${index}`"
                            >
                              {{ item }}
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div
                        class="col-12 mt-2"
                        v-if="service && service.termsConditions"
                      >
                        <div class="card pb-3 mb-0">
                          <div class="data-block mb-2">
                            <span class="title-block f-14"
                              >Terms and Conditions</span
                            >
                            <span class="content-block">
                              {{ service.termsConditions }}</span
                            >
                          </div>
                        </div>
                      </div>

                      <div class="col-xl-12 col-12 mt-2">
                        <div class="card box-created">
                          <span>
                            <strong>Created: </strong>
                            {{ formatPickupDate(createdAt, formatDate) }}-
                            {{ formatPickupTime(createdAt, formatTime) }}
                            by <strong>{{ responsibleName }}</strong>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-4 col-lg-12">
                <Charges
                  :serviceType="'transfer'"
                  :collapse="collapse"
                  :display="display"
                  :operation="operation"
                  :currency="currency"
                  :pricing="reservation.pricing"
                  @addAdjustments="addAdjustments"
                  :mode="mode"
                />

                <div class="row">
                  <div
                    class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12 box-flex"
                    v-if="!disabledElement(owner)"
                  >
                    <div class="card py-3">
                      <div class="row">
                        <div class="col-12">
                          <h2 class="subtitle mb-1">Payment Details</h2>
                          <div class="item-selected">
                            <span>
                              <strong>Payment Type: </strong>
                              {{ formatPaymentType(reservation.payment_type) }}
                            </span>
                          </div>
                          <div
                            class="item-selected"
                            v-if="reservation.invoice_number"
                          >
                            <span>
                              <strong>Invoice N°: </strong>
                              {{ reservation.invoice_number }}
                              <el-tooltip content="Copy" placement="bottom">
                                <span
                                  class="curp ml-2"
                                  v-clipboard:copy="reservation.invoice_number"
                                  v-clipboard:success="onCopy"
                                  v-clipboard:error="onErrorCopy"
                                >
                                  <i class="flaticon-copy link ml-0"></i>
                                </span> </el-tooltip
                            ></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12 box-flex"
                    v-if="
                      reservation.booking_reference && !disabledElement(owner)
                    "
                  >
                    <div class="card card py-3">
                      <h2 class="subtitle mb-1">External References</h2>

                      <div
                        class="item-selected"
                        v-if="reservation.booking_reference"
                      >
                        <span>
                          <strong>Reservation Reference: </strong>
                          {{ reservation.booking_reference }}
                          <el-tooltip content="Copy" placement="bottom">
                            <span
                              class="curp ml-2"
                              v-clipboard:copy="reservation.booking_reference"
                              v-clipboard:success="onCopy"
                              v-clipboard:error="onErrorCopy"
                            >
                              <i class="flaticon-copy link ml-0"></i>
                            </span> </el-tooltip
                        ></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="mode === 'edit'" class="forms">
          <div class="col-12">
            <div class="row">
              <div class="col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                <div class="row">
                  <div class="col-12">
                    <div class="card pb-4">
                      <h2 class="subtitle">Type Transfer</h2>
                      <div
                        class="option-transfers d-xl-block d-lg-block d-md-block d-sm-block d-none"
                      >
                        <b-form-radio-group
                          id="btn-radios-1"
                          v-model="reservation.type"
                          :options="reservationOptions"
                          name="radios-btn-default"
                          buttons
                          value-field="value"
                          text-field="label"
                          button-variant="group-neutral"
                          tabindex="1"
                          class="buttons-type"
                          @change="changeReservationTransferType"
                        ></b-form-radio-group>
                      </div>

                      <div
                        class="d-xl-none d-lg-none d-md-none d-sm-none d-block"
                      >
                        <WSelect
                          placeholder="Reservation Type"
                          v-model="reservation.type"
                          filterable
                          id="reservationType"
                          class="mb-0"
                        >
                          <el-option
                            v-for="option in reservationOptions"
                            :value="option.value"
                            :label="option.label"
                            :key="option.label"
                          ></el-option>
                        </WSelect>
                      </div>
                    </div>
                  </div>

                  <!-- address/date/time/ -->
                  <div class="col-xl-12">
                    <div class="card">
                      <h2 class="subtitle mb-4">Address / Date & Time</h2>
                      <div class="row">
                        <div class="col-12">
                          <WSelect
                            label="From"
                            v-bind:class="{
                              'is-invalid': $v.reservation.from.$error
                            }"
                            id="from"
                            name="from"
                            filterable
                            remote
                            reserve-keyword
                            :remote-method="getLocationFrom"
                            :loading="loading"
                            placeholder="Address or Hotel Name"
                            v-model="$v.reservation.from.$model"
                            @change="selectFrom"
                            indexTab="2"
                            ref="from"
                            :focusact="true"
                            no-data-text="Search by destination or landmark"
                            clearable
                            allText
                            :error="fromValidationMessage($v.reservation.from)"
                          >
                            <el-option
                              v-for="(location, index) in optionsFrom"
                              class
                              :value="location.select"
                              :label="location.select"
                              :key="`${index}`"
                            >
                              <div class="d-flex align-items-center">
                                <i :class="getIcon(location.type)"></i>
                                <span class="ml-3">
                                  {{ location.select }}
                                </span>
                              </div>
                            </el-option>
                          </WSelect>
                        </div>

                        <div
                          class="col-12"
                          v-show="reservation.type !== 'hourly'"
                        >
                          <WSelect
                            label="To"
                            v-bind:class="{
                              'is-invalid': $v.reservation.to.$error
                            }"
                            id="to"
                            name="to"
                            filterable
                            remote
                            reserve-keyword
                            :remote-method="getLocationTo"
                            :loading="loading"
                            placeholder="Address or Hotel Name"
                            v-model="$v.reservation.to.$model"
                            @change="selectTo"
                            indexTab="3"
                            no-data-text="Search by destination or landmark"
                            clearable
                            allText
                            :error="toValidationMessage($v.reservation.to)"
                            markrequired
                          >
                            <el-option
                              v-for="(location, index) in optionsTo"
                              :value="location.select"
                              :label="location.select"
                              :key="`${index}`"
                            >
                              <div class="d-flex align-items-center">
                                <i :class="getIcon(location.type)"></i>
                                <span class="ml-3">
                                  {{ location.select }}
                                </span>
                              </div>
                            </el-option>
                          </WSelect>
                        </div>

                        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                          <base-input
                            label="Pickup Date"
                            :error="
                              $v.reservation.pickup_date.$error
                                ? `Select Pickup Date`
                                : ''
                            "
                            markrequired
                          >
                            <flat-picker
                              slot-scope="{ focus, blur }"
                              @on-open="focus"
                              @on-close="blur"
                              :config="{
                                altFormat: 'd-M-Y',
                                altInput: true,
                                dateFormat: 'Y-m-d',
                                allowInput: true
                              }"
                              class="input-custom"
                              v-model="reservation.pickup_date"
                              @input="getRatesWithThePickupDate"
                              id="date"
                              name="date"
                              placeholder="Pickup Date"
                              tabindex="4"
                            ></flat-picker>
                          </base-input>
                        </div>
                        <div class="col-xl-2 col-lg-3 col-md-3 col-sm-6 col-12">
                          <base-input
                            label="Pickup Time"
                            :error="
                              $v.reservation.pickup_time.$error
                                ? `Select Pickup Time`
                                : ''
                            "
                            markrequired
                          >
                            <flat-picker
                              slot-scope="{ focus, blur }"
                              @on-open="focus"
                              @on-close="blur"
                              :config="{
                                altFormat: formatTimeFlatPicker.altFormat,
                                enableTime: true,
                                noCalendar: true,
                                dateFormat: formatTimeFlatPicker.dateFormat,
                                time_24hr: formatTimeFlatPicker.time_24hr,
                                wrap: true
                              }"
                              class="input-custom"
                              v-model="reservation.pickup_time"
                              @input="getRatesWithThePickupTime"
                              id="time"
                              name="time"
                              placeholder="Pickup Time"
                              tabindex="5"
                            ></flat-picker>
                          </base-input>
                        </div>
                        <div class="col-xl-2 col-lg-3 col-md-3 col-sm-6 col-6">
                          <base-input
                            class
                            type="number"
                            v-auto-zero
                            v-model.number="
                              $v.reservation.passengersCount.$model
                            "
                            label="PAX N°"
                            placeholder="PAX N°"
                            id="passengers"
                            name="passengers"
                            mode="integer"
                            indexTab="6"
                            markrequired
                            :error="
                              passengerCountValidationMessage(
                                $v.reservation.passengersCount
                              )
                            "
                            @input="getRatesWithTheNumberPassengers"
                          />
                        </div>

                        <div
                          class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 form-group"
                          v-if="
                            ['airport', 'arrival', 'departure'].includes(
                              reservation.type
                            )
                          "
                        >
                          <FlightNumberInput
                            v-model="$v.reservation.flight_number.$model"
                            :pickupDate="reservation.pickup_date"
                            :pickupTime="reservation.pickup_time"
                            :flightType="getFlightType(reservation.type)"
                            :validation="$v.reservation.flight_number"
                            :airport="airport"
                            :airportName="
                              getAirportName(
                                reservation.type,
                                reservation.from,
                                reservation.to
                              )
                            "
                            @input="onFlightNumberInput"
                            @validation-state="handleValidationState"
                            @selectFlight="handleFlightSelection"
                          />
                        </div>
                        <div
                          class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6 mb-3"
                          v-if="reservation.type === 'station'"
                        >
                          <base-input
                            v-model.trim="$v.reservation.number_stations.$model"
                            label="Rail Line"
                            id="rail_line"
                            name="rail_line"
                            placeholder="Rail Line"
                            indexTab="8"
                            @input="changeRouterReference"
                            :error="
                              $v.reservation.number_stations.$error
                                ? 'Enter a Valid Rail Line'
                                : ''
                            "
                          />
                        </div>

                        <div
                          class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6 mb-3"
                          v-if="reservation.type === 'port'"
                        >
                          <base-input
                            v-model.trim="$v.reservation.cruise_line.$model"
                            label="Cruise Ship"
                            id="cruise_line"
                            name="cruise_line"
                            placeholder="Cruise Ship"
                            indexTab="8"
                            @input="changeRouterReference"
                            :error="
                              $v.reservation.cruise_line.$error
                                ? 'Enter a Valid Cruise Ship'
                                : ''
                            "
                          />
                        </div>

                        <div
                          class="col-xl-2 col-lg-3 col-md-3 col-sm-6 col-6 mb-3"
                          v-if="reservation.type === 'hourly'"
                        >
                          <WSelect
                            class
                            v-bind:class="{
                              'is-invalid': $v.reservation.number_hourly.$error
                            }"
                            placeholder="Select Hourly"
                            v-model.trim="$v.reservation.number_hourly.$model"
                            @input="getRatesWithTheHourly"
                            id="number_hourly"
                            name="number_hourly"
                            indexTab="8"
                            label="Hourly"
                            @change="changeRouterReference"
                            :error="
                              $v.reservation.number_hourly.$error
                                ? 'Select an Hours'
                                : ''
                            "
                          >
                            <el-option
                              v-for="number in minimumSelect"
                              :value="number"
                              :label="number"
                              :key="number"
                            ></el-option>
                          </WSelect>
                        </div>
                        <div
                          class="col-12"
                          v-if="reservation.flight_number && flight"
                        >
                          <FlightDetails mode="edit" :flight="flight" />
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- service/destination -->
                  <div class="col-xl-12" v-if="showRates">
                    <div
                      class="card pb-4"
                      v-bind:class="{
                        'invalid-card': $v.reservation.service.$error
                      }"
                    >
                      <div class="row">
                        <div
                          class="col-xl-4 col-lg-4 col-md-4 col-sm-7 col-7 align-self-center"
                        >
                          <h2 class="subtitle">Service / Destination</h2>
                        </div>
                        <div
                          class="col-xl-8 col-lg-8 col-md-8 col-sm-5 col-5 text-right form-group-no-margin align-self-center"
                        >
                          <div
                            class="service-filters"
                            v-if="serviceAux.length > 0"
                          >
                            <div class="col-filter no-mov">
                              <WSelect
                                placeholder="Destination"
                                v-model="branchFilter"
                                id="branchFilter"
                                name="branchFilter"
                                filterable
                                indexTab="10"
                                @change="changeBranch"
                                label="Destination"
                                class="select-filter"
                                clearable
                              >
                                <el-option
                                  v-for="branch in branchesOptions"
                                  :value="branch._id"
                                  :label="branch.name"
                                  :key="branch._id"
                                ></el-option>
                              </WSelect>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mt-2">
                        <div class="col-xl-12">
                          <base-alert
                            v-if="loaderService == 'NOT_FOUND'"
                            type="danger"
                            class="mb-4 info-min"
                          >
                            <i class="flaticon-warning mr-1"></i>
                            <strong>Not Found!</strong> There are no services
                            available for your search. Check the from and to.
                          </base-alert>

                          <div class="container-services">
                            <div class="content-service">
                              <div v-if="loaderService === 'RESULTS'">
                                <div
                                  class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pad-org"
                                  v-for="(element, index) in serviceAux"
                                  :key="index"
                                >
                                  <ServicesCard
                                    :branches="branchesOptions"
                                    :selected="
                                      getSelectServices(service, element)
                                    "
                                    :transferType="reservation.type"
                                    :service="element"
                                    @selectService="processServiceSelection"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div v-if="loaderService === 'SEARCHING'">
                            <div class="text-center pt-0 pb-4">
                              <h4><strong>Finding services...</strong></h4>
                              <span class="loader-pin"></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-xl-12" v-else>
                    <div
                      class="card pb-4"
                      v-bind:class="{
                        'invalid-card': $v.reservation.service.$error
                      }"
                    >
                      <div class="row">
                        <div
                          class="col-xl-4 col-lg-4 col-md-4 col-sm-7 col-7 align-self-center"
                        >
                          <h2 class="subtitle">Service / Destination</h2>
                        </div>
                        <div
                          class="col-xl-8 col-lg-8 col-md-8 col-sm-5 col-5 text-right form-group-no-margin align-self-center"
                        >
                          <div class="service-filters">
                            <div class="col-filter mr-2">
                              <base-button
                                class="min-button"
                                type="outline-neutral"
                                @click="requote()"
                              >
                                <i class="flaticon-pencil mr-2"></i>
                                Edit
                              </base-button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-xl-12">
                          <div class="col-xl-12">
                            <div class="row">
                              <div
                                class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pad-org"
                                v-if="service !== null"
                              >
                                <ServicesCard
                                  :styleCard="'single'"
                                  :branches="branchesOptions"
                                  :selected="false"
                                  :service="service"
                                  :transferType="reservation.type"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Driver -->
                  <div class="col-xl-12">
                    <div class="card">
                      <h2 class="subtitle mb-4">Driver</h2>
                      <div class="row">
                        <div
                          class="col-xl-4 col-lg-8 col-md-9 col-sm-8 col-9 no-margin mb-4"
                        >
                          <WSelect
                            placeholder="Select Driver"
                            id="driver"
                            v-model="driverId"
                            @change="changeDriver"
                            name="driver"
                            indexTab="13"
                            clearable
                            filterable
                            :disabled="
                              disabledDriver(
                                reservationStatus,
                                reservation.driver
                              )
                            "
                            label="Driver Assigned"
                          >
                            <el-option
                              v-for="(item, index) in driversOptions"
                              :value="item._id"
                              :label="
                                `${item.person.first_name} ${item.person.last_name}`
                              "
                              :key="index"
                            ></el-option>
                          </WSelect>
                        </div>

                        <div class="col-xl-3 col-lg-4 col-md-3 col-sm-4 col-3">
                          <base-button
                            @click="showAddModalDriver = true"
                            class="min-button"
                            type="outline-neutral"
                          >
                            <i
                              class="flaticon-plus mr-2 d-sm-inline-block d-none"
                            ></i>
                            <span class="d-sm-inline-block d-none">
                              Add New</span
                            >
                            <span class="d-sm-none d-inline-block"> Add</span>
                          </base-button>
                        </div>
                      </div>
                      <div class="row" v-if="driverId">
                        <div class="col-xl-12 mb-4">
                          <div class="row">
                            <div
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-8 col-11 align-self-center"
                            >
                              <div class="box-card-lic" v-if="driver">
                                <div class="card-person link-img-profile">
                                  <a
                                    :href="`/edit-driver/${driverId}`"
                                    target="blank"
                                  >
                                    <div
                                      class="img-driver"
                                      v-bind:style="{
                                        backgroundImage: driver.profile.image
                                          ? `url('${driver.profile.image}')`
                                          : 'url(' + imageProfile + ')'
                                      }"
                                    ></div>
                                  </a>
                                  <div class="content">
                                    <div>
                                      <label>Driver: </label
                                      ><span
                                        >{{ driver.person.first_name }}
                                        {{ driver.person.last_name }}</span
                                      >
                                    </div>
                                    <div>
                                      <label>Phone: </label
                                      ><span
                                        ><a
                                          :href="
                                            `tel:${driver.person.numbre_phone}`
                                          "
                                          >{{ driver.person.numbre_phone }}</a
                                        >
                                      </span>
                                    </div>
                                    <div v-if="driver.account.email">
                                      <label>Email: </label>
                                      <span
                                        ><a
                                          :href="
                                            `mailto:${driver.account.email}`
                                          "
                                          >{{ driver.account.email }}</a
                                        >
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div
                              class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-1 text-left pl-0 align-self-center"
                            >
                              <el-tooltip content="Edit" placement="bottom">
                                <a
                                  class="icon-action text-blue mr-2 d-block"
                                  :href="`/edit-driver/${driverId}`"
                                  target="blank"
                                >
                                  <i class="flaticon-pencil text-primary"></i>
                                </a>
                              </el-tooltip>
                            </div>
                          </div>
                        </div>
                      </div>

                      <AddDrivers
                        :show="showAddModalDriver"
                        :branchId="reservation.branch"
                        @close="closeNewDriverModal"
                        @input="addDriversInOptions"
                      />
                    </div>
                  </div>

                  <!-- customer/passenger -->
                  <div class="col-xl-12">
                    <div class="card pb-3">
                      <h2 class="subtitle mb-4">Customer / PAX</h2>
                      <div class="row">
                        <div
                          class="col-xl-6 col-lg-6 col-md-7 col-sm-8 col-9 no-margin mb-4"
                        >
                          <WSelect
                            label="Customer"
                            v-bind:class="{
                              'is-invalid': $v.reservation.customer.$error
                            }"
                            class
                            filterable
                            remote
                            :remote-method="getCustomer"
                            :loading="loading"
                            placeholder="Enter Name Customer"
                            v-model="$v.reservation.customer.$model"
                            id="customer"
                            name="customer"
                            indexTab="14"
                            @input="selectCustomer"
                            no-data-text="Search by Customer"
                            clearable
                            markrequired
                          >
                            <el-option
                              v-for="(customer, index) in customers"
                              :value="customer._id"
                              :label="getCustomerName(customer)"
                              :key="index"
                            >
                              <div class="row">
                                <div class="col-7">
                                  {{ getCustomerName(customer) }}
                                </div>
                                <div class="col-5 text-right hide-data">
                                  <span class="coin-right">{{
                                    parseCustomerType(customer.type)
                                  }}</span>
                                </div>
                              </div>
                            </el-option>
                          </WSelect>
                          <small
                            class="invalid-feedback"
                            v-if="$v.reservation.customer.$error"
                            >Enter a Customer</small
                          >

                          <div v-if="copyData" class="text-right">
                            <base-button
                              class="linkfill"
                              @click="copyDataCustomer"
                              tabindex="15"
                              v-if="
                                sesion.role === 'supplier' && owner != 'admin'
                              "
                              >+ Fill Customer Data</base-button
                            >
                          </div>
                        </div>
                        <add-customers
                          :show="modalCustomer"
                          @closeNewCustomerModal="closeNewCustomerModal"
                          @customer="addCustomerInOptions"
                        ></add-customers>

                        <div class="col-xl-4 col-lg-4 col-md-3 col-sm-4 col-3">
                          <base-button
                            @click="modalCustomer = true"
                            class="min-button"
                            type="outline-neutral"
                            v-if="
                              sesion.role === 'supplier' && owner != 'admin'
                            "
                          >
                            <i
                              class="flaticon-plus mr-1 d-sm-inline-block d-none"
                            ></i>
                            <span class="d-sm-inline-block d-none">
                              Add New</span
                            >
                            <span class="d-sm-none d-inline-block"> Add</span>
                          </base-button>
                        </div>

                        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                          <base-input
                            v-model.trim="passenger.firstName"
                            label="PAX First Name"
                            placeholder="PAX First Name"
                            id="first_name_passenger"
                            name="first_name_passenger"
                            format="capitalize"
                            indexTab="17"
                            @input="populatePassengers()"
                            :error="
                              !$v.passenger.firstName.minLength ||
                              !$v.passenger.firstName.ValName
                                ? `Minimum 2 letters`
                                : ''
                            "
                          />
                        </div>

                        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                          <base-input
                            v-model.trim="passenger.lastName"
                            label="PAX Last Name"
                            placeholder="PAX Last Name"
                            indexTab="18"
                            id="last_name_passenger"
                            format="capitalize"
                            name="last_name_passenger"
                            @input="populatePassengers()"
                            :error="
                              !$v.passenger.lastName.minLength ||
                              !$v.passenger.lastName.ValName
                                ? `Minimum 2 letters`
                                : ''
                            "
                          />
                        </div>

                        <div
                          class="col-xl-3 col-lg-3 col-md-3 col-sm-4 col-12 mb-4"
                        >
                          <label for="title" class="title-label">Title</label>

                          <b-form-group
                            v-slot="{ ariaDescribedby }"
                            class="mb-0"
                          >
                            <b-form-radio-group
                              id="radio-gender"
                              v-model="passenger.gender"
                              :aria-describedby="ariaDescribedby"
                              name="radio-gender"
                              buttons
                              button-variant="outline-neutral"
                              size="md"
                              @change="populatePassengers()"
                            >
                              <b-form-radio
                                value="male"
                                class="pc-4"
                                tabindex="15"
                                >Mr.</b-form-radio
                              >
                              <b-form-radio value="female" class="pc-4"
                                >Mrs.</b-form-radio
                              >
                              <b-form-radio value="other" class="pc-4"
                                >Mx.</b-form-radio
                              >
                            </b-form-radio-group>
                          </b-form-group>
                        </div>

                        <div class="col-xl-5 col-lg-6 col-md-6 col-sm-6 col-12">
                          <base-input
                            v-if="
                              sesion.role === 'supplier' && owner === 'admin'
                            "
                            :value="''"
                            label="PAX Email"
                            placeholder="PAX Email"
                            indexTab="19"
                            id="passengers_email"
                            name="passengers_email"
                            format="lowercase"
                            :disabled="true"
                          />
                          <base-input
                            v-else
                            v-model.trim="passenger.email"
                            label="PAX Email"
                            placeholder="PAX Email"
                            indexTab="19"
                            id="passengers_email"
                            name="passengers_email"
                            format="lowercase"
                            @input="populatePassengers()"
                            :error="
                              !$v.passenger.email.minLength ||
                              !$v.passenger.email.email
                                ? `Enter a valid email`
                                : ''
                            "
                          />
                        </div>
                        <div
                          class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12 inputphone"
                        >
                          <label class="title-label">Contact Number</label>
                          <vue-tel-input
                            v-model="contactNumber"
                            key="NumberPhone"
                            inputId="NumberPhone"
                            name="NumberPhone"
                            required
                            mode="international"
                            inputClasses="input no-err"
                            :dynamicPlaceholder="true"
                            :disabledFetchingCountry="true"
                            :validCharactersOnly="true"
                            @input="onPassengerPhoneInput"
                            :inputOptions="{ tabindex: 19 }"
                          ></vue-tel-input>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-xl-12">
                    <div class="card pb-3">
                      <h2 class="subtitle">Pickup Sign</h2>

                      <div class="row">
                        <div
                          class="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12 align-self-center"
                        >
                          <div v-if="pdfDataUrl">
                            <div class="pdfPreview mb-4">
                              <iframe
                                :src="pdfDataUrl"
                                width="235px"
                                height="160px"
                                frameborder="0"
                                allowfullscreen
                                class="pdf-iframe"
                                scrolling="no"
                              ></iframe>

                              <el-tooltip
                                content="Open / Expand"
                                placement="bottom"
                              >
                                <div
                                  class="overlay-expand"
                                  @click="openPreviewPickup()"
                                >
                                  <i class="flaticon-expand"></i></div
                              ></el-tooltip>

                              <el-tooltip
                                content="Remove Pickup Sign"
                                placement="bottom"
                              >
                                <div
                                  class="overlay-remove"
                                  @click="clearfile()"
                                >
                                  <i class="flaticon-delete"></i></div
                              ></el-tooltip>
                            </div>
                          </div>

                          <el-input
                            v-else
                            v-model="reservation.pickupSign.text"
                            placeholder="Pickup Sign"
                            id="pickupSign"
                            name="pickupSign"
                            maxlength="200"
                            type="textarea"
                            :autosize="{ minRows: 1, maxRows: 5 }"
                            show-word-limit
                          >
                          </el-input>
                        </div>
                        <div
                          class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 align-self-center alinmov2 mt-mb-0 mt-2"
                          v-if="!pdfDataUrl"
                        >
                          <base-button
                            type="outline-neutral mr-2"
                            class="link min-button"
                            @click="uploadPickupSign"
                          >
                            <i class="flaticon-up-2"></i> Upload Pickup Sign
                            <input
                              type="file"
                              ref="pickupSign"
                              accept=".pdf"
                              model="pickupSign"
                              @change="readPickupSign"
                              class="d-none"
                            />
                          </base-button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-xl-12">
                    <div class="card">
                      <h2 class="subtitle mb-3">Extras</h2>

                      <div class="row">
                        <div
                          class="col-xl-9 col-lg-9 col-md-9 col-sm-12 col-12 mb-3"
                        >
                          <label class="title-label" for="specialrequirements"
                            >Special Requirements</label
                          >
                          <el-input
                            v-model="reservation.special_requirements"
                            placeholder="Special Requirements"
                            id="Special Requirements"
                            name="Special Requirements"
                            maxlength="500"
                            type="textarea"
                            :autosize="{ minRows: 1, maxRows: 10 }"
                            show-word-limit
                          >
                          </el-input>
                        </div>

                        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                          <base-input
                            type="number"
                            v-auto-zero
                            v-model.number="
                              $v.reservation.childSeatsCount.$model
                            "
                            mode="integer"
                            label="Child Seats N°"
                            id="child_seat"
                            name="child_seat"
                            placeholder="Child Seat"
                            indexTab="7"
                            :error="
                              childSeatsCountValidationMessage(
                                $v.reservation.childSeatsCount
                              )
                            "
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-xl-12 col-12">
                    <div class="card box-created">
                      <span>
                        <strong>Created:</strong>
                        {{ formatPickupDate(createdAt, formatDate) }}-
                        {{ formatPickupTime(createdAt, formatTime) }} by
                        <strong>{{ responsibleName }}</strong>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-4 col-lg-12 pl-xl-0">
                <Charges
                  :serviceType="'transfer'"
                  :collapse="collapse"
                  :display="display"
                  :operation="operation"
                  :currency="currency"
                  :pricing="reservation.pricing"
                  @addAdjustments="addAdjustments"
                  :mode="mode"
                />

                <div class="row">
                  <div
                    class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12"
                    v-if="!disabledElement(owner)"
                  >
                    <div class="card pb-3">
                      <h2 class="subtitle mb-3">Payment Details</h2>

                      <div class="row">
                        <div
                          class="col-xl-12 col-lg-6 col-md-6 col-sm-6 col-12"
                        >
                          <WSelect
                            placeholder="Payment Type"
                            v-model="reservation.payment_type"
                            id="paymentType"
                            name="paymentType"
                            @change="changePaymentType"
                            label="Payment Type"
                          >
                            <el-option
                              v-for="option in paymentMethods"
                              :value="option.value"
                              :label="option.label"
                              :key="option.label"
                            ></el-option>
                          </WSelect>
                        </div>

                        <div
                          class="col-xl-12 col-lg-6 col-md-6 col-sm-6 col-12"
                        >
                          <base-input
                            v-model.trim="reservation.invoice_number"
                            type="text"
                            label="Invoice Number"
                            placeholder="Invoice Number"
                            id="invoice_number"
                            name="invoice_number"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12"
                    v-if="!disabledElement(owner)"
                  >
                    <div class="card pb-3">
                      <h2 class="subtitle mb-3">External References</h2>

                      <div class="row">
                        <div
                          class="col-xl-12 col-lg-12 col-md-12 col-sm-6 col-12"
                        >
                          <base-input
                            type="text"
                            label="Reservation Reference"
                            placeholder="Reservation Reference"
                            v-model="$v.reservation.booking_reference.$model"
                            id="booking_reference"
                            name="booking_reference"
                            indexTab="28"
                            :error="
                              $v.reservation.booking_reference.$error
                                ? `Enter maximum ${$v.reservation.booking_reference.$params.maxLength.max} characters.`
                                : ''
                            "
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ManageExtraCharges
      :show="showExtrasModal"
      :markUp="customer ? customer.mark_up : 0"
      :markUpType="customer ? customer.type_markup : ''"
      :extras="reservation.pricing.extras"
      :currency="currency"
      @change="manageExtras"
      @close="closeExtrasModal"
    />
    <ManageDiscounts
      :show="showDiscountModal"
      :grossPrice="reservation.pricing.gross_price.last_amount"
      :discounts="reservation.pricing.discounts"
      :currency="currency"
      @change="manageDiscounts"
      @close="closeDiscountModal"
    />
    <ReservationHistory
      :show="showReservationHistory"
      :tempReservationId="tempReservationId"
      :bookingNumber="tempBookingNumber"
      @close="closeReservationHistoryModal"
    />
    <modal
      v-if="pdfDataUrl"
      :show.sync="showPreviewPickupSign"
      modal-classes="modal-dialog-centered modal-xl"
      body-classes="pt-1"
    >
      <template slot="header">
        <h4 class="subtitle mb-0" id="BlackoutDate">Pickup Sign</h4>
      </template>

      <iframe
        :src="`${pdfDataUrl}#zoom=100`"
        width="100%"
        height="600px"
      ></iframe>
    </modal>
  </section>
</template>

<script>
// @ is an alias to /src
import { v4 as uuidv4 } from "uuid";
import moment from "moment-timezone";
moment.suppressDeprecationWarnings = true;
import { mapGetters, mapActions, mapMutations } from "vuex";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import endpoint from "../../Commons/Services/index";
import Swal from "sweetalert2";
import { helpers } from "vuelidate/lib/validators";
const ValName = helpers.regex("alphaCha", /^[a-zA-ZÑñáéíóúüüÜÁÉÍÓÚ'-\s]*$/);
import { VueTelInput } from "vue-tel-input";
import WSelect from "@/components/Select";
import AddCustomers from "../components/AddCustomers";
import ManageExtraCharges from "../components/ManageExtrasCharges";
import ManageDiscounts from "../components/ManageDiscounts";
import Charges from "../components/Charges";
import PaymentStatus from "../components/PaymentStatus";
import AddDrivers from "../components/AddDriver";
import ServicesCard from "../components/ServicesCard.vue";
import ReservationHistory from "../components/ReservationHistory.vue";
import upload from "../../Commons/Utility/Upload";
import path from "path";
import {
  required,
  minLength,
  maxLength,
  alphaNum,
  email,
  maxValue,
  minValue,
  numeric,
  integer,
  requiredIf
} from "vuelidate/lib/validators";
import {
  Tabs,
  TabPane,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  DatePicker,
  TimeSelect,
  MessageBox,
  Message
} from "element-ui";
import { cloneDeep, isEqual, isEmpty } from "lodash";
import debounce from "lodash.debounce";
import {
  FIELDS_PASSENGER_VIEW,
  MINIMUM_SELECT,
  PAYMENT_METHODS,
  RESERVATION_OPTIONS,
  calculateHoursDifference,
  canCancelBooking,
  cancelBooking,
  canCompleteBooking,
  canDeleteBooking,
  canResendBookingEmail,
  completeBooking,
  resendBookingNotifications,
  canShowActionItem,
  canConfirmBooking,
  confirmBooking,
  canMarkBookingAsNoShow,
  noShowBooking,
  getFlightType,
  getAirportDetails,
  populateFromOptions,
  populateToOptions,
  getAirportName,
  getLabelTransport,
  getTransportReference
} from "../../../helpers/reservation.helpers";
import {
  formatBookingType,
  formatPaymentType,
  formatPickupDate,
  formatPickupTime,
  formatVehicleCategory,
  formatFromLocationForRequest,
  formatToLocationForRequest
} from "../services/format.service";
import { goBack, unauthorizedAction } from "../../../helpers/commons.helpers";

import FlightNumberInput from "../components/FlightValidation/FlightNumberInput.vue";
import FlightDetails from "../components/FlightValidation/FlightDetails.vue";
import {
  generateMessageToNotify,
  getPickupDate,
  getPickupTime
} from "../services/flight.service";

import {
  childSeatsCountValidationMessage,
  fromValidationMessage,
  passengerCountValidationMessage,
  toValidationMessage
} from "../services/validation.service";
import {
  buildUtcPickupDateTime,
  canBeRequoted,
  handleBlackoutConfirmation,
  handleCutOffConfirmation
} from "../services/quote.service";
import {
  calculateTotalDiscounts,
  calculateTotalExtraGrossPrice,
  calculateTotalExtrasNetPrice,
  calculateTotalGrossPrice,
  calculateTotalNetPrice,
  calculateTotalNetProfit,
  calculateTotalPrice,
  isSamePriceComposition,
  isSameSurchargesComposition,
  normalizePriceAmount
} from "../services/price.service";
import { populateDriver, populateService } from "../services/populate.service";
import { alphabeticallySort } from "../services/client.service";

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};

export default {
  name: "EditReservation",
  data() {
    return {
      debouncedRequote: null,
      reservation: {
        from: "",
        to: "",
        pickup_date: "",
        pickup_time: "",
        passengersCount: 0,
        childSeatsCount: 0,
        type: "arrival",
        supplier: null,
        branch: null,
        service: null,
        driver: null,
        vehicle: null,
        payment_type: "card",
        payment_reference: "",
        flight_number: "",
        customer: null,
        booking_reference: "",
        pickupSign: {
          format: "CUSTOM",
          text: "",
          link: ""
        },
        special_requirements: "",
        number_hourly: 0,
        invoice_number: 0,
        number_stations: "",
        cruise_line: "",
        irraival: false,
        surcharges: [],
        locations: {
          from: {
            lat: 0,
            lng: 0
          },
          to: {
            lat: 0,
            lng: 0
          }
        },
        distancematrix: {
          distance: 0,
          duration: 0
        },
        originData: null,
        destinationData: null,
        chauffeur: {
          name: "",
          email: "",
          phone: "",
          gender: ""
        },
        passengers: [],
        pricing: {
          net_price: {
            amount: 0.0,
            last_amount: 0.0,
            composition: []
          },
          base_price: {
            amount: 0.0,
            last_amount: 0.0,
            composition: []
          },
          gross_price: {
            amount: 0.0,
            last_amount: 0.0,
            composition: []
          },
          net_profit: {
            amount: 0.0,
            last_amount: 0.0,
            composition: []
          },
          sale_price: {
            amount: 0.0,
            last_amount: 0.0,
            composition: []
          },
          discounts: [],
          extras: [],
          totals: {
            discounts: 0.0,
            extras: {
              gross_price: 0.0,
              net_price: 0.0,
              net_profit: 0.0
            },
            net_price: 0.0,
            gross_price: 0.0,
            net_profit: 0.0
          },
          reason_adjustment: ""
        },
        notificaition: {
          configTag: "rhomtrip_supplier",
          configRef: null
        },
        source: {
          origin: "RhomTrip Suppliers",
          type: "INTERNAL",
          provider: "RHOMTRIP",
          channel: "SYSTEM",
          medium: "APP"
        },
        flight: null
      },
      contactNumber: "",
      pickupDate: "",
      paymentMethods: PAYMENT_METHODS,
      reservationOptions: RESERVATION_OPTIONS,
      services: [],
      serviceAux: [],
      all_services: [],
      booking_number: "",
      customer: null,
      minimumSelect: MINIMUM_SELECT,
      branchesOptions: [],
      branchFilter: "",
      driverFilter: "",
      branch: null,
      loading: false,
      optionsFrom: [],
      customers: [],
      optionsTo: [],
      currentPage: 1,
      service: null,
      type_request: "one_way",
      show: 0,
      saved: false,
      reservationCopy: {},
      currency_symbol: "",
      currency_code: "",
      customerIni: false,
      surcharges: [],
      driversOptions: [],
      drivers: [],
      driver: null,
      country_code: "",
      owner: "admin",
      modalCustomer: false,
      automaticDriverSelection: true,
      originData: null,
      destinationData: null,
      viewReview: false,
      loaderService: "SEARCHING",
      onLoad: true,
      reservationId: "",
      showRates: false,
      driverId: null,
      imageProfile: require("rhomtrip_assets/src/img/users/user-placeholder.png"),
      passenger: {
        _id: null,
        reference: uuidv4(),
        firstName: "",
        lastName: "",
        fullName: "",
        email: "",
        phone: "",
        gender: "other",
        type: "ADULT",
        primary: true,
        flightNumber: ""
      },
      extraCard: true,
      mode: "view",
      createdAt: "",
      cardDiscount: true,
      showDiscountModal: false,
      showExtrasModal: false,
      paymentLinkStatus: "",
      paymentLink: "",
      copyData: false,
      responsibleName: "",
      currency: {
        symbol: "",
        code: ""
      },
      customerId: null,
      showAddModalDriver: false,
      reservationOwner: "rhomtrip",
      collapse: false,
      display: "net_price",
      operation: "none",
      supplier: {
        name: "",
        email: "",
        phone: "",
        gender: ""
      },
      isOurReserve: false,
      fieldsPassengerView: FIELDS_PASSENGER_VIEW,
      statusUpdate: false,
      pdfDataUrl: null,
      showPreviewPickupSign: false,
      routerReference: {
        transferType: "arrival",
        value: ""
      },
      timezone: "",
      flights: [],
      flightType: "NONE",
      flight: null,
      airport: null,
      flightValidationRoles: {},
      childSeats: false,
      reservationStatus: "",
      loaderVerifyFlight: false,
      showReservationHistory: false,
      tempReservationId: "",
      tempBookingNumber: ""
    };
  },
  watch: {
    "reservation.type": {
      handler: function(current, old) {
        if (current === "hourly") {
          this.reservation.to = "";
          this.type_request = "hourly";
        } else {
          this.type_request = "one_way";
        }
      },
      deep: true
    },
    "reservation.branch": {
      handler: function(current, old) {
        if (current) {
          let branch = this.branchesOptions.find(
            branch => branch._id === current
          );
          if (branch) {
            this.branch = branch;
          }
        }
      },
      deep: true
    },
    customerOptions: {
      handler: function(current, old) {
        this.customers = current;
      },
      deep: true
    }
  },
  async created() {
    this.debouncedRequote = debounce(this.requote, 500);
    var bread = [
      {
        text: "Reservations",
        to: "/reservations"
      },
      {
        text: "Reservation Details",
        active: true
      }
    ];
    this.setItemsBread(bread);
    this.getSesion();
    this.onLoad = true;
    this.setLoad(true);
    this.customers = this.customerOptions;
    this.reservationId = this.$route.params.id;
    await this.loadReservation(this.reservationId);
    this.onLoad = false;
    this.setLoad(false);
  },
  methods: {
    canCancelBooking,
    cancelBooking,
    canCompleteBooking,
    completeBooking,
    calculateHoursDifference,
    canResendBookingEmail,
    resendBookingNotifications,
    canDeleteBooking,
    canShowActionItem,
    canConfirmBooking,
    confirmBooking,
    canMarkBookingAsNoShow,
    noShowBooking,
    formatPickupDate,
    formatPickupTime,
    formatVehicleCategory,
    formatBookingType,
    formatPaymentType,
    getFlightType,
    getAirportDetails,
    getAirportName,
    fromValidationMessage,
    toValidationMessage,
    passengerCountValidationMessage,
    childSeatsCountValidationMessage,
    getLabelTransport,
    getTransportReference,
    normalizePriceAmount,
    openReservationHistoryModal(reservationId, bookingNumber) {
      this.tempReservationId = reservationId;
      this.tempBookingNumber = bookingNumber;
      this.showReservationHistory = true;
    },
    closeReservationHistoryModal() {
      this.showReservationHistory = false;
    },
    /**
     * Init Reservation
     */
    async loadReservation(id) {
      try {
        let { data } = await endpoint.reservations.services.getReservation(id);
        if (data.status) {
          let reservation = data.data;
          this.reservationOwner =
            reservation.owner === "admin" ? "rhomtrip" : "rhomtrip-supplier";
          this.collapse = this.reservationOwner !== "rhomtrip";
          this.display =
            this.reservationOwner !== "rhomtrip" ? "all" : "net_price";
          this.operation =
            this.reservationOwner !== "rhomtrip" ? "edit" : "none";
          this.reservation.payment_reference = reservation.payment_reference;

          this.statusUpdate = reservation.status_update;
          this.pickupDate = reservation.pickup_date;
          this.timezone = reservation.branch.timezone;

          this.booking_number = reservation.booking_number;
          this.reservation.booking_reference = reservation.booking_reference;
          this.reservation.source = reservation.source;

          /** Flight Info */
          this.flight = reservation.flight
            ? cloneDeep(reservation.flight)
            : null;
          this.reservation.flight = this.flight;

          /**Address / Date & Time */
          this.reservation.locations.to = reservation.locations.to;
          this.reservation.locations.from = reservation.locations.from;

          this.reservation.distancematrix.distance =
            reservation.distancematrix.distance;
          this.reservation.distancematrix.duration =
            reservation.distancematrix.duration;

          this.reservation.originData = reservation.originData
            ? reservation.originData
            : null;
          this.reservation.destinationData = reservation.destinationData
            ? reservation.destinationData
            : null;
          this.originData = this.reservation.originData;
          this.destinationData = this.reservation.destinationData;

          this.optionsFrom = populateFromOptions(
            reservation.from,
            reservation.type,
            this.originData,
            reservation.irraival
          );
          if (reservation.to) {
            this.optionsTo = populateToOptions(
              reservation.to,
              reservation.type,
              this.destinationData,
              reservation.irraival,
              reservation.flight_number
            );
          }

          this.reservation.to = reservation.to;
          this.reservation.from = reservation.from;
          /** */
          this.reservation.pickup_date = moment(reservation.pickup_date)
            .utc(false)
            .format("YYYY-MM-DD");

          this.reservation.pickup_time = moment(
            reservation.pickup_time,
            "h:mm A"
          ).format(this.formatTime);

          this.reservation.passengersCount = reservation.passengersCount;
          this.reservation.childSeatsCount = reservation.childSeatsCount;
          this.reservation.type = reservation.type;
          this.reservation.number_stations = reservation.number_stations;
          this.reservation.cruise_line = reservation.cruise_line;
          this.reservation.number_hourly = reservation.number_hourly;

          /** Flight Number */
          this.reservation.flight_number = reservation.flight_number;
          this.flightType = this.getFlightType(this.reservation.type);
          this.airport = this.getAirportDetails(
            this.reservation.type,
            this.optionsFrom,
            this.optionsTo
          );

          this.routerReference = this.getRouterReference(
            this.reservation.type,
            this.reservation.flight_number,
            this.reservation.number_stations,
            this.reservation.cruise_line,
            this.reservation.number_hourly
          );

          /**Add driver in reservation */
          this.driversOptions = await this.getDriverOptions(
            reservation.branch._id
          );

          if (reservation.driver !== null) {
            let driverId = reservation.driver._id;
            this.driver = populateDriver(reservation.driver);
            let isDriverInclude = this.driversOptions
              .map(driver => driver._id)
              .includes(driverId);
            if (!isDriverInclude) {
              this.driversOptions.push(this.driver);
            }
            this.driverId = driverId;
            this.reservation.driver = driverId;
            this.reservation.chauffeur = {
              name: `${this.driver.person.first_name} ${this.driver.person.last_name}`,
              email: this.driver.account.email,
              phone: this.driver.person.numbre_phone,
              gender: this.driver.person.gender
            };
          } else {
            this.reservation.driver = null;
            this.reservation.chauffeur = cloneDeep(reservation.chauffeur);
          }

          /**Service / Destination */
          this.reservation.supplier = reservation.supplier._id;
          this.supplier = {
            name: reservation.supplier.businessDetails.name,
            email: reservation.supplier.authentication.email,
            phone: this.getContactNumber(
              true,
              reservation.supplier.contactPerson.phoneNumbers
            ),
            gender: ""
          };

          /**Add branch in reservations */
          this.branchFilter = reservation.branch._id;
          this.branchesOptions.push(reservation.branch);
          this.reservation.branch = reservation.branch._id;
          this.branch = reservation.branch;

          /**Add service in reservations */
          this.reservation.service = reservation.service._id;
          let vehicle = reservation.vehicle
            ? reservation.vehicle
            : reservation.service.vehicle;
          this.reservation.vehicle = vehicle._id;

          this.service = populateService(reservation, vehicle);

          this.serviceAux.push(this.service);
          this.services.push(this.service);
          this.all_services = this.services;
          this.reservation.surcharges = reservation.surcharges;
          this.currency.symbol = this.service.currency.symbol;
          this.currency.code = this.service.currency.code;

          /**Add Customer in reservations */

          if (reservation.customer !== null) {
            let ifExist = this.customers.find(
              element => element._id === reservation.customer._id
            );
            if (ifExist === undefined) {
              this.customers.push(reservation.customer);
            }
            this.customers = alphabeticallySort(this.customers);
            this.reservation.customer = reservation.customer._id;
            this.customer = this.customers.find(
              element => element._id === reservation.customer._id
            );
            this.customerId = reservation.customer._id;
          }

          /** */
          this.reservation.payment_type = reservation.payment_type;
          this.reservation.passengers = reservation.passengers;
          if (this.reservation.passengers.length) {
            [this.passenger] = this.reservation.passengers;
            this.contactNumber = `${this.passenger.phone}`;
          }

          /** Price and Fee*/
          this.reservation.pricing = reservation.pricing;
          this.reservation.invoice_number = reservation.invoice_number;
          this.reservation.pickupSign = reservation.pickupSign;
          this.pdfDataUrl =
            this.reservation.pickupSign.format === "FILE" &&
            this.reservation.pickupSign.link
              ? this.reservation.pickupSign.link
              : null;
          this.reservation.special_requirements =
            reservation.special_requirements;
          this.reservationStatus = reservation.status;
          this.reservation.payment_type = reservation.payment_type;

          this.reservation.notificaition.configTag =
            reservation.notificaition.configTag;
          this.reservation.notificaition.configRef =
            reservation.notificaition.configRef;

          this.owner = reservation.owner;
          this.reservationCopy = cloneDeep(this.reservation);
          this.responsibleName = this.getResponsibleName(
            reservation.responsible
          );
          this.isOurReserve = this.whoIsTheOwner(reservation.responsible);
          this.createdAt = reservation.created_at;
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        console.log(error);
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The Operation could not be completed. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    /*<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<Pricing Methods>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/
    calculePriceByCustomer(netPrice, markUp, markUpType) {
      let grossPrice =
        markUpType === "markup"
          ? netPrice / (1 - markUp / 100)
          : netPrice * (1 - markUp / 100);

      let totalGrossPrice = calculateTotalPrice(
        parseFloat(grossPrice.toFixed(2)),
        this.reservation.surcharges,
        "gross"
      );
      this.reservation.pricing.gross_price.amount = parseFloat(
        totalGrossPrice.toFixed(2)
      );
      this.reservation.pricing.gross_price.last_amount = this.reservation.pricing.gross_price.amount;

      let netProfit = this.reservation.pricing.gross_price.amount - netPrice;
      this.reservation.pricing.net_profit.amount = parseFloat(
        netProfit.toFixed(2)
      );
      this.reservation.pricing.net_profit.last_amount = this.reservation.pricing.net_profit.amount;

      this.populatePricing(
        this.reservation.pricing.extras,
        this.reservation.pricing.discounts
      );
    },
    populatePricing(extras = [], discounts = []) {
      //Calculate Total Extras Net Price
      this.reservation.pricing.totals.extras.net_price = calculateTotalExtrasNetPrice(
        extras
      );
      //Calculate Total Extra Gross Price
      this.reservation.pricing.totals.extras.gross_price = calculateTotalExtraGrossPrice(
        extras
      );
      //Calculate Total Extras Net Profit
      this.reservation.pricing.totals.extras.net_profit =
        this.reservation.pricing.totals.extras.gross_price -
        this.reservation.pricing.totals.extras.net_price;

      //Calculate Total Discounts
      this.reservation.pricing.totals.discounts = calculateTotalDiscounts(
        discounts
      );

      //Calculate Total Net Price
      this.reservation.pricing.totals.net_price = calculateTotalNetPrice([
        this.reservation.pricing.totals.extras.net_price,
        this.reservation.pricing.net_price.last_amount
      ]);

      //Calculate Total Gross Price
      let totalsGrossPrice = calculateTotalGrossPrice([
        this.reservation.pricing.totals.extras.gross_price,
        this.reservation.pricing.gross_price.last_amount
      ]);
      this.reservation.pricing.totals.gross_price =
        totalsGrossPrice - this.reservation.pricing.totals.discounts;

      //Calculate Total Net profit
      this.reservation.pricing.totals.net_profit = calculateTotalNetProfit(
        this.reservation.pricing.totals.gross_price,
        this.reservation.pricing.totals.net_price,
        0,
        0
      );
    },
    openDiscountModal() {
      this.showDiscountModal = true;
    },
    closeDiscountModal() {
      this.showDiscountModal = false;
    },
    manageDiscounts(discounts = []) {
      this.reservation.pricing.discounts = discounts;
      this.populatePricing(
        this.reservation.pricing.extras,
        this.reservation.pricing.discounts
      );
      this.showDiscountModal = false;
    },
    openExtrasModal() {
      this.showExtrasModal = true;
    },
    closeExtrasModal() {
      this.showExtrasModal = false;
    },
    manageExtras(extras = []) {
      this.reservation.pricing.extras = extras;
      this.populatePricing(
        this.reservation.pricing.extras,
        this.reservation.pricing.discounts
      );
      this.showExtrasModal = false;
    },
    addAdjustments(adjustment) {
      if (adjustment === "discounts") {
        this.openDiscountModal();
      } else {
        this.openExtrasModal();
      }
    },
    getGroosPrice(netPrice, markUp, markUpType, customerExists) {
      if (customerExists) {
        return markUpType === "markup"
          ? netPrice / (1 - markUp / 100)
          : netPrice * (1 - markUp / 100);
      }
      return netPrice / 0.7;
    },
    /*<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<Passenger & Customer Methods>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/
    populatePassengers() {
      this.passenger.fullName = `${this.passenger.firstName} ${this.passenger.lastName}`;
      this.passenger.primary = true;
      this.reservation.passengers = [this.passenger];
      this.populatePickupSign();
    },
    addCustomerInOptions(customer) {
      if (customer !== null) {
        this.customers.push(customer);
        this.customers = alphabeticallySort(this.customers);
        this.customer = customer;
        this.reservation.customer = customer._id;
        this.setCustomerOptions(this.customerOptions.concat([customer]));
      }
    },
    closeNewCustomerModal(status) {
      this.modalCustomer = false;
      if (!status) {
        this.reservation.customer = this.customer._id;
      }
    },
    async getCustomer(input = "") {
      try {
        if (input !== "" && input.length > 2) {
          this.loading = true;
          this.customers = this.customerOptions.filter(customer => {
            let name = `${customer.first_name} ${customer.last_name}`;
            return (
              name.toLowerCase().includes(input.trim().toLowerCase()) ||
              customer.company_name.toLowerCase().includes(input.toLowerCase())
            );
          });
          this.loading = false;
        } else {
          this.customers = this.customerOptions;
        }
      } catch (error) {
        this.customers = this.customerOptions;
      }
    },
    copyDataCustomer() {
      if (this.customer) {
        this.passenger.firstName = this.customer.first_name;
        this.passenger.lastName = this.customer.last_name;
        this.passenger.fullName = `${this.customer.first_name} ${this.customer.last_name}`;
        this.passenger.email = this.customer.email;
        this.passenger.phone = this.customer.phone;
        this.contactNumber = this.customer.phone;
        this.passenger.gender = this.customer.gender;
        this.passenger.flightNumber = this.reservation.flight_number;
        this.passenger.primary = true;
        this.reservation.passengers = [this.passenger];
        this.populatePickupSign();
      }
    },
    getCustomerName(customer) {
      if (customer) {
        if (customer.relationship.type === "supplier") {
          if (customer.company_name !== "") {
            return customer.company_name;
          } else {
            return `${customer.first_name} ${customer.last_name}`;
          }
        }
        return "RhomTrip";
      }
      return "";
    },
    async selectCustomer(customerId) {
      if (customerId) {
        if (!this.service) {
          this.$notify({
            type: "warning",
            title: "Important!",
            message: `We have detected that you have not selected any available service.`,
            icon: "flaticon-warning-1"
          });
          this.reservation.customer = null;
        } else {
          this.customer = this.customers.find(customer => {
            return customer._id === customerId;
          });
          let customer = this.customer;
          this.copyData = true;
          this.calculePriceByCustomer(
            this.reservation.pricing.net_price.last_amount,
            customer.mark_up,
            customer.type_markup
          );
        }
      }
    },
    onPassengerPhoneInput(value, payload) {
      let result = payload;
      if (result.isValid) {
        this.passenger.phone = result.number.e164;
        this.passenger.primary = true;
        this.reservation.passengers = [this.passenger];
      }
    },
    parseCustomerType(type) {
      if (type === "customer") {
        return "Customer";
      } else if (type === "travel_agency") {
        return "Travel Agency";
      } else if (type === "business") {
        return "Business";
      } else if (type === "travel_access") {
        return "Agent";
      } else {
        return "Customer";
      }
    },
    getPassengerType(type) {
      if (type === "ADULT") {
        return "Adult";
      } else if (type === "SENIOR") {
        return "Senior";
      } else {
        return "Child";
      }
    },
    /*<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<Request Service Methods>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/
    async getRatesWithTheOrigin(value) {
      try {
        const isRequotable = canBeRequoted(
          this.reservation.type,
          value,
          this.reservation.to,
          this.reservation.pickup_date,
          this.reservation.pickup_time,
          this.reservation.passengersCount
        );
        if (isRequotable) {
          this.debouncedRequote();
        }
      } catch (error) {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: `Please verify your Address / Date & Time information.`,
          icon: "flaticon-warning-1"
        });
      }
    },
    async getRatesWithTheDestination(value) {
      try {
        const isRequotable = canBeRequoted(
          this.reservation.type,
          this.reservation.from,
          value,
          this.reservation.pickup_date,
          this.reservation.pickup_time,
          this.reservation.passengersCount
        );
        if (isRequotable) {
          this.debouncedRequote();
        }
      } catch (error) {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: `Please verify your Address / Date & Time information.`,
          icon: "flaticon-warning-1"
        });
      }
    },
    async getRatesWithThePickupDate(value) {
      try {
        const isRequotable = canBeRequoted(
          this.reservation.type,
          this.reservation.from,
          this.reservation.to,
          value,
          this.reservation.pickup_time,
          this.reservation.passengersCount
        );
        if (isRequotable) {
          this.debouncedRequote();
        }
      } catch (error) {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: `Please verify your Address / Date & Time information.`,
          icon: "flaticon-warning-1"
        });
      }
    },
    async getRatesWithThePickupTime(value) {
      try {
        const isRequotable = canBeRequoted(
          this.reservation.type,
          this.reservation.from,
          this.reservation.to,
          this.reservation.pickup_date,
          value,
          this.reservation.passengersCount
        );
        if (isRequotable) {
          this.debouncedRequote();
        }
      } catch (error) {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: `Please verify your Address / Date & Time information.`,
          icon: "flaticon-warning-1"
        });
      }
    },
    async getRatesWithTheNumberPassengers(value) {
      try {
        const isRequotable = canBeRequoted(
          this.reservation.type,
          this.reservation.from,
          this.reservation.to,
          this.reservation.pickup_date,
          this.reservation.pickup_time,
          parseInt(value)
        );
        if (isRequotable) {
          this.debouncedRequote();
        }
      } catch (error) {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: `Please verify your Address / Date & Time information.`,
          icon: "flaticon-warning-1"
        });
      }
    },
    async getRatesWithTheHourly(value) {
      try {
        const isRequotable = canBeRequoted(
          this.reservation.type,
          this.reservation.from,
          this.reservation.to,
          this.reservation.pickup_date,
          this.reservation.pickup_time,
          this.reservation.passengersCount
        );
        if (isRequotable && parseInt(value) > 0) {
          this.debouncedRequote();
        }
      } catch (error) {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: `Please verify your Address / Date & Time information.`,
          icon: "flaticon-warning-1"
        });
      }
    },
    buildRateOptionsRequestBody() {
      return {
        passengersCount: this.reservation.passengersCount,
        origin: formatFromLocationForRequest(
          this.reservation.from,
          this.reservation.type,
          this.originData
        ),
        destination: formatToLocationForRequest(
          this.reservation.to,
          this.reservation.type,
          this.destinationData
        ),
        pickup_date: this.reservation.pickup_date,
        pickup_time: this.reservation.pickup_time,
        type_request: this.type_request,
        arrival: this.flightType === "ARRIVAL",
        hours: this.reservation.number_hourly,
        childSeatsCount: this.reservation.childSeatsCount,
        serviceType: "TRANSFER",
        source: "rhombus-v1"
      };
    },
    async getBookingOptions() {
      try {
        const payload = this.buildRateOptionsRequestBody();
        this.loaderService = "SEARCHING";
        let {
          data
        } = await endpoint.rates.services.getTransferPricingQuotation(
          payload,
          this.sesion.token
        );
        if (data) {
          this.branchFilter = "";
          this.driverFilter = "";
          this.reservation.locations.from = data.origin;
          this.reservation.locations.to = data.destination;
          this.reservation.distancematrix.distance = data.distance;
          this.reservation.distancematrix.duration = data.duration;
          this.timezone = data.timezone;
          this.services = data.services;
          this.all_services = data.all_services;
          this.serviceAux = this.services;
          this.drivers = data.drivers;
          this.driversOptions = data.drivers;
          this.branchesOptions = data.branches;
          this.loaderService = this.serviceAux.length ? "RESULTS" : "NOT_FOUND";
        } else {
          this.services = [];
          this.branchesOptions = [];
          this.loaderService = "NOT_FOUND";
        }
      } catch (error) {
        this.services = [];
        this.branchesOptions = [];
        this.loaderService = "NOT_FOUND";
      }
    },
    async requote() {
      this.showRates = true;
      this.branchFilter = "";
      this.driverFilter = "";
      this.branchesOptions = [];
      this.driversOptions = [];
      await this.getBookingOptions();
      let serviceId = this.service ? this.service._id : null;
      let currentService = this.getServiceById(serviceId, this.services);
      this.reservation.service = null;
      this.service = null;
      if (currentService) {
        this.processServiceSelection(currentService);
      }
    },
    getServiceById(serviceId, services = []) {
      return services.find(service => service._id === serviceId) || null;
    },
    getSelectServices(serviceSelected, element) {
      if (serviceSelected) {
        return serviceSelected._id === element._id;
      }
      return false;
    },
    /*<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<Location Methods>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/
    getTypeLocation(type, origin) {
      if (type === "arrival" && origin === "from") {
        return "airport";
      } else if (type === "departure" && origin === "to") {
        return "airport";
      } else {
        return "point_of_interest";
      }
    },
    async populateOringData(from) {
      if (from) {
        let element = this.optionsFrom.find(item => item.select === from);
        if (element) {
          this.country_code = element.country_code;
          if (element.type === "airport") {
            this.originData = element;
            this.reservation.originData = element;
            this.flightType = "ARRIVAL";
            this.airport = element.metadata ? element.metadata : {};
          } else {
            // Keep Google selections so the backend can geocode by place_id.
            this.originData = element.place_id ? element : null;
            this.reservation.originData = this.originData;
          }
        }
      }
    },
    async populateDestinationData(to) {
      if (to) {
        let element = this.optionsTo.find(item => item.select === to);
        if (element) {
          if (element.type === "airport") {
            this.destinationData = element;
            this.reservation.destinationData = element;
            this.flightType = "DEPARTURE";
            this.airport = element.metadata ? element.metadata : {};
          } else {
            // Keep Google selections so the backend can geocode by place_id.
            this.destinationData = element.place_id ? element : null;
            this.reservation.destinationData = this.destinationData;
          }
        }
      }
    },
    async selectFrom(from) {
      await this.populateOringData(from);
      await this.getRatesWithTheOrigin(from);
    },
    async selectTo(to) {
      await this.populateDestinationData(to);
      await this.getRatesWithTheDestination(to);
    },
    async getLocationFrom(input) {
      try {
        if (input !== "" && input.length > 2) {
          let type = this.getTypeLocation(this.reservation.type, "from");
          this.loading = true;
          let {
            data
          } = await endpoint.countries.services.autocompleteLocations(
            input,
            type
          );
          this.loading = false;
          if (data.code === 200) {
            let locations = data.data;
            this.optionsFrom = locations;
          } else {
            this.optionsFrom = [];
          }
        } else {
          this.optionsFrom = [];
        }
      } catch (error) {
        this.optionsFrom = [];
      }
    },
    async getLocationTo(input) {
      try {
        if (input !== "" && input.length > 2) {
          let type = this.getTypeLocation(this.reservation.type, "to");
          this.loading = true;
          let {
            data
          } = await endpoint.countries.services.autocompleteLocations(
            input,
            type
          );
          this.loading = false;
          if (data.code === 200) {
            let locations = data.data;
            this.optionsTo = locations;
          } else {
            this.optionsTo = [];
          }
        } else {
          this.optionsTo = [];
        }
      } catch (error) {
        this.optionsTo = [];
      }
    },

    /*<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<Pickup Sign Methods>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/
    populatePickupSign() {
      this.reservation.pickupSign.format = "CUSTOM";
      this.reservation.pickupSign.text = `${this.getTitleByGender(
        this.passenger.gender
      )} ${this.passenger.firstName} ${this.passenger.lastName}`;
    },
    async uploadPickupSign(event) {
      this.$refs.pickupSign.click();
    },
    async readPickupSign(event) {
      this.reservation.pickupSign.text = "";
      this.reservation.pickupSign.format = "FILE";
      await this.uploadPickupSignFile(event);
    },
    async uploadPickupSignFile(event) {
      try {
        const [file] = event.target.files;
        if (file && file.type === "application/pdf") {
          if (file.size > 2 * 1024 * 1024) {
            event.preventDefault();
            this.$notify({
              type: "danger",
              title: "Error!",
              message: "The file can't be larger than 2MB",
              icon: "flaticon-remove"
            });
            this.clearfile();
          } else {
            this.pdfDataUrl = URL.createObjectURL(file);
            let urlFile = await upload.uploadFile(
              file,
              upload.buildQueryString(
                upload.getFileData(
                  "/uploads/pdf/signs",
                  path.extname(file.name)
                )
              )
            );
            if (urlFile) {
              this.reservation.pickupSign.link = urlFile;
            } else {
              this.$notify({
                type: "danger",
                title: "Error!",
                message:
                  "The image cannot be larger than 2MB or exceed 500px x 500px dimensions",
                icon: "flaticon-remove"
              });
            }
          }
        } else {
          this.$notify({
            type: "warning",
            title: "Warning!",
            message:
              "There is an error in the imported file, please check the data and try the upload again",
            icon: "flaticon-warning-1"
          });
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The file couldn't be imported. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    clearfile() {
      this.pdfDataUrl = null;
      this.reservation.pickupSign.link = "";
      this.populatePickupSign();
    },
    openPreviewPickup() {
      this.showPreviewPickupSign = true;
    },
    closePreviewPickupSign(status) {
      this.showPreviewPickupSign = status;
      this.pdfDataUrl = null;
    },
    /*<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<Service Selection Methods>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/
    async handleCutOff(confirmed, service) {
      if (confirmed) {
        await this.applyServiceToReservation(service, this.customer);
      } else {
        this.service = null;
        this.reservation.service = null;
      }
    },
    async handleBlackoutService(confirmed, service) {
      if (confirmed) {
        await this.handleServiceSelection(service);
      } else {
        this.service = null;
        this.reservation.service = null;
      }
    },
    async handleServiceSelection(service) {
      if (this.service) {
        const isDifferentServiceId = this.service._id !== service._id;
        const samePriceComposition = isSamePriceComposition(
          this.service.basePriceComposition,
          service.basePriceComposition
        );
        const sameSurchargesComposition = isSameSurchargesComposition(
          this.service.surcharges,
          service.surcharges
        );
        if (
          isDifferentServiceId ||
          !samePriceComposition ||
          !sameSurchargesComposition
        ) {
          await this.validateAndApplyService(service);
        }
        return;
      }
      await this.validateAndApplyService(service);
      return;
    },
    async processServiceSelection(service) {
      try {
        if (service.blackout) {
          await handleBlackoutConfirmation(service, this.handleBlackoutService);
        } else {
          await this.handleServiceSelection(service);
        }
      } catch (error) {
        this.service = null;
        this.reservation.service = null;
      }
    },
    async validateAndApplyService(service) {
      const isCutoffTimeApplied = service.isCutoffTimeApplied;
      if (!isCutoffTimeApplied) {
        await this.applyServiceToReservation(service, this.customer);
      } else {
        await handleCutOffConfirmation(service, this.handleCutOff);
      }
    },
    applyServiceToReservation(service, customer) {
      this.service = service;
      this.reservation.supplier = service.supplierId;
      this.reservation.branch = service.branchId;
      this.reservation.service = service._id;
      this.reservation.vehicle = service.vehicle._id;

      this.reservation.surcharges = service.surcharges;

      this.driverAssign(service.vehicle._id, this.automaticDriverSelection);

      let base_price = parseFloat(service.base_price.toFixed(2));
      this.reservation.pricing.base_price.amount = base_price;
      this.reservation.pricing.base_price.last_amount = base_price;
      this.reservation.pricing.base_price.composition =
        service.basePriceComposition;

      let sale_price = parseFloat(service.sale_price.toFixed(2));
      this.reservation.pricing.sale_price.amount = sale_price;
      this.reservation.pricing.sale_price.last_amount = sale_price;

      let net_price = calculateTotalPrice(
        base_price,
        this.reservation.surcharges,
        "net"
      );
      this.reservation.pricing.net_price.amount = parseFloat(
        net_price.toFixed(2)
      );
      this.reservation.pricing.net_price.last_amount = this.reservation.pricing.net_price.amount;

      this.currency.symbol = service.currency.symbol;
      this.currency.code = service.currency.code;
      if (customer) {
        this.calculePriceByCustomer(
          this.reservation.pricing.net_price.last_amount,
          customer.mark_up,
          customer.type_markup
        );
      }
    },
    /*<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<Save Reservation Methods>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/
    validateRecord(params, callback) {
      if (!this.$v.reservation.$invalid && !this.$v.passenger.$invalid) {
        callback(params);
      } else {
        this.$v.reservation.$touch();
        this.$v.passenger.$touch();
        if (this.$v.reservation.passengersCount.$invalid) {
          this.$notify({
            type: "warning",
            title: "Important!",
            message: `The number of PAX does not match the number of PAX added to the list.`,
            icon: "flaticon-warning-1"
          });
        } else {
          this.$notify({
            type: "warning",
            title: "Important!",
            message: "Please complete the required attributes",
            icon: "flaticon-warning-1"
          });
        }
      }
    },
    storeReservation(redirectTo = null) {
      this.validateRecord({ redirectTo }, this.saveReservation);
    },
    saveReservation({ redirectTo = null } = {}) {
      if (!this.hasChanges(this.reservation, this.reservationCopy)) {
        this.$router.push("/reservations");
        return;
      }

      if (this.reservationOwner === "rhomtrip") {
        this.assignDriver(this.reservationId, redirectTo);
        return;
      }

      const recipients = [];
      const { passengers } = this.reservation;
      if (!["JF", "SBC", "SCB", "BI"].includes(this.reservationStatus)) {
        recipients.push("CUSTOMER", "PASSENGER");
      }

      const isBiAndIncompletePassengers =
        this.reservationStatus === "BI" &&
        !this.hasCompletedPassenger(passengers);

      if (isBiAndIncompletePassengers) {
        recipients.push("CUSTOMER", "PASSENGER");
      }

      this.beforeUpdate(this.reservationId, recipients, redirectTo);
      return;
    },
    /**
     * Reservations not owned by the supplier only expose the Driver field
     * (see reservationOwner === "rhomtrip" gating in the template), so saving
     * them goes through the driver-only endpoint instead of the full PUT.
     */
    async assignDriver(reservationId, redirectTo = null) {
      try {
        this.setLoad(true);
        let {
          data
        } = await endpoint.reservations.services.assignDriverByReservationId(
          reservationId,
          { driverId: this.driverId, chauffeur: this.reservation.chauffeur },
          this.sesion.token
        );
        this.setLoad(false);
        this.saved = true;
        if (!data) {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
          return;
        }

        this.$notify({
          type: "success",
          title: "Success!",
          message: "The driver has been assigned",
          icon: "flaticon-check-3"
        });
        this.$router.push(redirectTo ? redirectTo : "/reservations");
        return;
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "There was an error assigning the driver, please try again"
        );
      }
    },
    async updateReservation(
      reservationId,
      reservation,
      recipients,
      reason,
      redirectTo = null
    ) {
      try {
        this.setLoad(true);
        let { data } = await endpoint.reservations.services.updateReservation(
          reservationId,
          reservation,
          recipients,
          reason,
          this.sesion.token
        );
        this.setLoad(false);
        this.saved = true;
        if (!data) {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
          return;
        }
        this.$notify({
          type: "success",
          title: "Success!",
          message: "The reservations has been Updated",
          icon: "flaticon-check-3"
        });
        this.$router.push(redirectTo ? redirectTo : "/reservations");
        return;
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "There was an error saving your reservation, please try again"
        );
      }
    },
    beforeUpdate(reservationId, recipients, redirectTo) {
      let reservation = cloneDeep(this.reservation);
      reservation.pickup_time = this.getPickupTime(
        reservation.pickup_time,
        this.formatTime
      );
      reservation.pickup_date = buildUtcPickupDateTime(
        reservation.pickup_date,
        reservation.pickup_time
      );
      reservation["irraival"] = this.flightType === "ARRIVAL";
      this.updateReservation(
        reservationId,
        reservation,
        recipients,
        "",
        redirectTo
      );
    },
    /*<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<Router Reference Methods>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/
    changeRouterReference(value) {
      this.routerReference = {
        transferType: this.reservation.type,
        value
      };
    },
    getRouterReferenceValue(transferType, routerReference) {
      if (transferType === routerReference.transferType) {
        return routerReference.value;
      } else {
        return transferType === "hourly" ? 0 : "";
      }
    },
    getRouterReference(
      transferType,
      flightNumber,
      stationNumber,
      cruiseLine,
      numberHourly
    ) {
      if (["arrival", "departure"].includes(transferType)) {
        return {
          transferType: transferType,
          value: flightNumber
        };
      } else if (transferType === "station") {
        return {
          transferType: transferType,
          value: stationNumber
        };
      } else if (transferType === "port") {
        return {
          transferType: transferType,
          value: cruiseLine
        };
      } else if (transferType === "hourly") {
        return {
          transferType: transferType,
          value: numberHourly
        };
      } else {
        return {
          transferType: transferType,
          value: ""
        };
      }
    },
    changeReservationTransferType(type) {
      let routerReferenceValue = this.getRouterReferenceValue(
        type,
        this.routerReference
      );
      if (["arrival", "departure"].includes(type)) {
        this.type_request = "one_way";
        this.reservation.flight_number = routerReferenceValue;
        this.reservation.number_stations = "";
        this.reservation.cruise_line = "";
        this.reservation.number_hourly = 0;
      } else if (type === "station") {
        this.type_request = "one_way";
        this.reservation.flight_number = "";
        this.reservation.number_stations = routerReferenceValue;
        this.reservation.cruise_line = "";
        this.reservation.number_hourly = 0;
      } else if (type === "port") {
        this.type_request = "one_way";
        this.reservation.flight_number = "";
        this.reservation.number_stations = "";
        this.reservation.cruise_line = routerReferenceValue;
        this.reservation.number_hourly = 0;
      } else if (type === "hourly") {
        this.type_request = "hourly";
        this.reservation.to = "";
        this.reservation.flight_number = "";
        this.reservation.number_stations = "";
        this.reservation.cruise_line = "";
        this.reservation.number_hourly = routerReferenceValue;
      } else {
        this.type_request = "one_way";
        this.reservation.flight_number = "";
        this.reservation.number_stations = "";
        this.reservation.cruise_line = "";
        this.reservation.number_hourly = 0;
      }
    },
    /*<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<Flight Methods>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/
    /**
     * Handle flight selection and update reservation details
     * @param {Object} payload - The flight selection payload
     */
    async handleFlightSelection(payload) {
      const { flight, isAdjustingDateTime, flightType } = payload;
      this.flight = flight;
      this.flight.isAdjustingDateTime = isAdjustingDateTime;
      this.flight.flightType = flightType;
      this.reservation.flight = cloneDeep(flight);
      this.changeRouterReference(this.reservation.flight_number);
      if (isAdjustingDateTime) {
        const date =
          flightType === "ARRIVAL" ? flight.arrivaltime : flight.departuretime;
        const timezone =
          flightType === "ARRIVAL"
            ? flight.destination.timezone
            : flight.origin.timezone;

        this.reservation.pickup_date = getPickupDate(date, timezone);
        if (flightType === "ARRIVAL") {
          this.reservation.pickup_time = getPickupTime(
            date,
            timezone,
            this.formatTime
          );
        }
        this.$notify({
          type: "info",
          title: "Important!",
          message: generateMessageToNotify(flightType),
          icon: "flaticon-notification-bell-outline-interface-symbol"
        });
        await this.booking();
      }
    },
    /**
     * Handle flight validation rules
     * @param {Object} rules - The flight validation rules
     */
    handleValidationState(rules) {
      this.flightValidationRoles = { ...rules };
    },
    /**
     * Reset flight details when flight number input changes
     */
    onFlightNumberInput(flightNumber) {
      if (!flightNumber) {
      }
    },
    async getFlightsInformationByIdent(ident) {
      this.loaderVerifyFlight = true;
      try {
        let {
          data
        } = await endpoint.flights.services.getFlightsInformationByIdent(
          ident,
          this.sesion.token
        );
        if (data.status) {
          window.open(
            `https://www.flightaware.com/live/flight/${data.data.ident}`,
            "_blank"
          );
        } else {
          this.$notify({
            type: "warning",
            title: "Important!",
            message: `We couldn't display the details of your flight. Please try again later.`,
            icon: "flaticon-warning-1"
          });
        }
      } catch (error) {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: `We couldn't display the details of your flight. Please try again later.`,
          icon: "flaticon-warning-1"
        });
      }
      this.loaderVerifyFlight = false;
    },

    /*<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<Driver Methods>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/
    getDriverByVehivleId(vehicleId) {
      try {
        let driver = this.drivers.find(element => {
          return element.relationship.vehicle === vehicleId;
        });
        return driver ? driver : null;
      } catch (error) {
        return null;
      }
    },
    changeDriver(driverId) {
      let driver = this.driversOptions.find(driver => driver._id === driverId);
      if (driver) {
        this.reservation.driver = driverId;
        this.driver = populateDriver(driver);
        this.reservation.chauffeur = {
          name: `${this.driver.person.first_name} ${this.driver.person.last_name}`,
          email: this.driver.account.email,
          phone: this.driver.person.numbre_phone,
          gender: this.driver.person.gender
        };
        this.automaticDriverSelection = false;
      } else {
        this.reservation.chauffeur = {
          name: "Local RhomTrip Supplier",
          email: this.supplier.email,
          phone: this.supplier.phone,
          gender: ""
        };
        this.driver = null;
        this.driverId = null;
        this.reservation.driver = null;
        this.automaticDriverSelection = true;
      }
    },
    driverAssign(vehicleId, automaticDriverSelection) {
      if (!automaticDriverSelection) {
        this.driverId = this.driver._id;
        this.reservation.driver = this.driverId;
        this.reservation.chauffeur = {
          name: `${this.driver.person.first_name} ${this.driver.person.last_name}`,
          email: this.driver.account.email,
          phone: this.driver.person.numbre_phone,
          gender: this.driver.person.gender
        };
        this.automaticDriverSelection = false;
      } else {
        this.driver = this.getDriverByVehivleId(vehicleId);
        if (this.driver && this.driver.relationship.auto_assign) {
          this.driverId = this.driver._id;
          this.reservation.driver = this.driverId;
          this.reservation.chauffeur = {
            name: `${this.driver.person.first_name} ${this.driver.person.last_name}`,
            email: this.driver.account.email,
            phone: this.driver.person.numbre_phone,
            gender: this.driver.person.gender
          };
          this.automaticDriverSelection = true;
        } else {
          this.driver = null;
          this.driverId = null;
          this.reservation.driver = this.driverId;
          this.reservation.chauffeur = {
            name: "Local RhomTrip Supplier",
            email: this.supplier.email,
            phone: this.supplier.phone,
            gender: ""
          };
          this.automaticDriverSelection = true;
        }
      }
    },
    disabledDriver(status, driverId) {
      if (["", null].includes(driverId)) {
        return false;
      } else {
        if (["POB", "DSR", "DAP", "JF"].includes(status)) {
          return true;
        }
        return false;
      }
    },
    addDriversInOptions(driver) {
      if (driver) {
        this.driversOptions.push(driver);
        this.driverId = driver._id;
        this.reservation.driver = this.driverId;
        this.driver = populateDriver(driver);
        this.reservation.chauffeur = {
          name: `${this.driver.person.first_name} ${this.driver.person.last_name}`,
          email: this.driver.account.email,
          phone: this.driver.person.numbre_phone,
          gender: this.driver.person.gender
        };
      }
      this.showAddModalDriver = false;
    },
    closeNewDriverModal(status) {
      this.showAddModalDriver = false;
    },
    async getDriverOptions(branchId) {
      try {
        let {
          data
        } = await endpoint.reservations.services.getDriversByBranchId(
          branchId,
          this.sesion.token
        );
        if (data.status) {
          return data.data;
        }
        return [];
      } catch (error) {
        return [];
      }
    },
    /*<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<Helpers Methods>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/
    getPickupTime(pickupTime, formatTime) {
      return moment(pickupTime, formatTime).format("hh:mm A");
    },
    disabledElement(owner) {
      if (["supplier", "supplier_access"].includes(this.sesion.role)) {
        return owner === "admin" ? true : false;
      }
      return false;
    },
    changeBranch(value) {
      if (value !== "") {
        this.driverFilter = "";
        this.services = this.all_services;
        this.serviceAux = this.services.filter(service => {
          return service.branchId === value;
        });
        this.driversOptions = this.drivers.filter(element => {
          return element.relationship.branch === value;
        });
      } else {
        this.driverFilter = "";
        this.serviceAux = this.all_services;
        this.driversOptions = this.drivers;
      }
    },
    getIcon(type) {
      if (type === "airport") {
        return "flaticon-bold-plane";
      } else if (type === "lodging") {
        return "flaticon-bold-bed";
      } else if (type === "point_of_interest") {
        return "flaticon-bold-map";
      } else if (type === "route") {
        return "flaticon-bold-distance";
      } else if (type === "train_station" && type === "transit_station") {
        return "flaticon-bold-train";
      } else {
        return "flaticon-bold-map";
      }
    },
    hasChanges(currentValue, previousValue) {
      return !isEqual(currentValue, previousValue);
    },
    hasCompletedPassenger(passengers = []) {
      return passengers.some(p => p.firstName && p.lastName);
    },
    handleError(error, message) {
      if (error.response) {
        let { data } = error.response;
        if (data.code === 401) {
          let auth = unauthorizedAction(error);
          if (auth) {
            this.setSigOut(true);
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: message,
          icon: "flaticon-remove"
        });
      }
    },
    goToPreviousPage() {
      goBack(this);
    },
    changePaymentType(value) {
      if (value !== "credit") {
        this.creditAvailable = true;
      }
    },
    getTitleByGender(gender) {
      if (gender === "male") {
        return "Mr.";
      } else if (gender === "female") {
        return "Mrs.";
      } else if (gender === "other") {
        return "Mx.";
      } else {
        return "";
      }
    },
    onCopy() {
      this.$notify({
        type: "success",
        title: "Success!",
        message: "The text has been copied to the clipboard",
        icon: "flaticon-remove"
      });
    },
    onErrorCopy() {
      this.$notify({
        type: "danger",
        title: "Error!",
        message: "The text couldn't be copied",
        icon: "flaticon-remove"
      });
    },
    getResponsibleName(responsible) {
      try {
        if (responsible.type === "Customers") {
          return "RhomTrip";
        } else if (responsible.type === "Operators") {
          return `${responsible.ref.contactPerson.firstName} ${responsible.ref.contactPerson.lastName}`;
        } else if (responsible.type === "Users") {
          if (["supplier_access"].includes(responsible.ref.relationship.type)) {
            return `${responsible.ref.personal_info.first_name} ${responsible.ref.personal_info.last_name}`;
          } else {
            return "RhomTrip";
          }
        } else {
          return "Unknown";
        }
      } catch (error) {
        return "Unknown";
      }
    },
    whoIsTheOwner(responsible) {
      if (responsible) {
        if (responsible.type === "Customers") {
          return false;
        } else if (responsible.type === "Operators") {
          return true;
        } else if (responsible.type === "Users") {
          return ["supplier_access"].includes(
            responsible.ref.relationship.type
          );
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    getContactNumber(status, phoneNumbers = []) {
      let contactNumber = phoneNumbers.find(
        phone => phone.preferred === status
      );
      if (contactNumber) {
        return contactNumber.number;
      } else {
        return "";
      }
    },
    getLabelToHeaderTable(type) {
      if (["airport", "arrival", "departure"].includes(type)) {
        return "Flight N°";
      } else if (type === "station") {
        return "Rail Line";
      } else if (type === "port") {
        return "Cruise Ship";
      } else {
        return "";
      }
    },
    getHeaderPassengerTable(files = [], transferType) {
      return files
        .filter(file => {
          if (["hourly", "journey"].includes(transferType)) {
            return file.key !== "itinerary";
          } else {
            return true;
          }
        })
        .map(file => {
          if (file.key === "itinerary") {
            file.label = this.getLabelToHeaderTable(transferType);
          }
          return file;
        });
    },
    getLabelStatus(status, statusUpdate) {
      if (status === "SC") {
        if (statusUpdate) {
          return "Reconfirm";
        }
      }
      return this.getReservationStatus(status);
    },
    getReservationStatus(status) {
      if (status === "NW") {
        return "New";
      } else if (["SBC", "SCB"].includes(status)) {
        return "Cancelled";
      } else if (status === "SC") {
        return "Confirmed";
      } else if (status === "JF") {
        return "Completed";
      } else if (status === "SRB") {
        return "Rejected";
      } else if (status === "DA") {
        return "Driver Accepted";
      } else if (status === "DSR") {
        return "Driver Started Trip";
      } else if (status === "DAP") {
        return "Driver on Location";
      } else if (status === "POB") {
        return "POB";
      } else if (status === "NS") {
        return "No Show";
      } else if (status === "DRR") {
        return "Driver Rejected";
      } else {
        return "Draft";
      }
    },
    getStatusClass(currentstatus, statusUpdate, owner, pickupDate, timeZone) {
      if (currentstatus === "NW") {
        if (owner === "admin") {
          let cutOff = this.isWithin72Hours(pickupDate, timeZone);
          return cutOff ? "status-new critical-new" : "status-new";
        } else {
          return statusUpdate ? "status-reconfirm" : "status-new";
        }
      } else if (currentstatus === "SC") {
        return statusUpdate ? "status-reconfirm" : "status-confirmed";
      } else if (["SCB", "SBC"].includes(currentstatus)) {
        return "status-cancelled";
      } else if (currentstatus === "SRB") {
        return "status-rejected";
      } else if (["DA", "DSR", "DAP", "POB"].includes(currentstatus)) {
        return "status-started";
      } else if (currentstatus === "JF") {
        return "status-completed";
      } else if (currentstatus === "NS") {
        return "status-noshow";
      } else if (currentstatus === "BI") {
        return "status-draft";
      } else if (currentstatus === "DRR") {
        return "status-rejected";
      } else {
        return {};
      }
    },
    isWithin72Hours(pickupDate, timeZone) {
      let currentDate = moment.tz(timeZone).utc(true);
      let thresholdDate = moment(pickupDate).subtract(72, "hours");
      return (
        currentDate.isAfter(thresholdDate) && currentDate.isBefore(pickupDate)
      );
    },

    /**
     * Booking Actions
     */
    async cancelBookingById(bookingId, reason) {
      try {
        this.setLoad(true);
        let {
          data
        } = await endpoint.reservations.services.cancelReservationById(
          bookingId,
          reason,
          this.sesion.token
        );
        this.setLoad(false);
        if (!data) {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Reservation can't be Cancelled",
            icon: "flaticon-remove"
          });
        }
        this.$notify({
          type: "success",
          title: "Success!",
          message: "The Reservation has been Cancelled",
          icon: "flaticon-check-3"
        });
        await this.loadReservation(bookingId);
        return;
      } catch (error) {
        this.setLoad(false);
        this.handleError(error, "The Reservation can't be cancelled");
      }
    },
    async changeBookingStatus(bookingId, status, reason = "") {
      try {
        this.setLoad(true);
        let {
          data
        } = await endpoint.reservations.services.changeRservationStatus(
          bookingId,
          status,
          reason,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The reservation have been updated successfully",
            icon: "flaticon-check-3"
          });
          await this.loadReservation(bookingId);
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The reservation could not be updated",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    handleResendBookingNotifications(bookingId, recipients = []) {
      if (recipients.length > 0) {
        this.resendBookingNotificationsById(bookingId, recipients);
      } else {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "No notification was sent, you must select a recipient",
          icon: "flaticon-warning-1"
        });
      }
    },
    async resendBookingNotificationsById(bookingId, recipients) {
      try {
        this.setLoad(true);
        let {
          data
        } = await endpoint.reservations.services.resendEmailToUsersByReservationId(
          bookingId,
          recipients,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The notifications have been forwarded successfully",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The notifications couldn't be sent",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The operation couldn't be completed. Please try again"
        );
      }
    },
    async confirmReservationById(id) {
      try {
        this.setLoad(true);
        let {
          data
        } = await endpoint.reservations.services.confirmReservationById(
          id,
          {},
          this.sesion.token
        );
        this.setLoad(false);
        if (!data) {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Reservation cannot be Confirmed",
            icon: "flaticon-remove"
          });
          return;
        }
        this.$notify({
          type: "success",
          title: "Success!",
          message: "The Reservation has been Confirmed",
          icon: "flaticon-check-3"
        });
        await this.loadReservation(id);
        return;
      } catch (error) {
        console.log(error);
        this.setLoad(false);
        this.handleError(error, "The Reservation cannot be Confirmed");
      }
    },
    ...mapActions(["getLocations", "getSesion"]),
    ...mapMutations([
      "setSigOut",
      "setLoad",
      "setCustomerOptions",
      "setItemsBread"
    ])
  },
  components: {
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    [MessageBox.name]: MessageBox,
    [Message.name]: Message,
    flatPicker,
    VueTelInput,
    WSelect,
    AddCustomers: AddCustomers,
    ManageExtraCharges: ManageExtraCharges,
    ManageDiscounts: ManageDiscounts,
    Charges: Charges,
    PaymentStatus: PaymentStatus,
    AddDrivers: AddDrivers,
    "add-customers": AddCustomers,
    ServicesCard: ServicesCard,
    FlightNumberInput,
    FlightDetails,
    ReservationHistory: ReservationHistory
  },
  validations: {
    contactNumber: {
      required,
      minLength: minLength(10),
      maxLength: maxLength(18)
    },
    reservation: {
      from: {
        required
      },
      to: {
        required: requiredIf(function(value) {
          return this.reservation.type !== "hourly";
        }),
        differentFromPickup: function(value) {
          if (this.reservation.type === "hourly") return true;
          return value !== this.reservation.from;
        }
      },
      pickup_date: {
        required
      },
      pickup_time: {
        required
      },
      passengersCount: {
        required,
        numeric,
        integer,
        minValue: minValue(1),
        maxValue: maxValue(85),
        customValidator: function(value) {
          return this.reservation.passengers.length <= value;
        }
      },
      customer: {
        required,
        alphaNum
      },
      service: {
        required
      },
      number_hourly: {
        required: requiredIf(function() {
          return this.reservation.type === "hourly";
        }),
        minValue: function(value) {
          if (this.reservation.type !== "hourly") return () => true;
          return value > 1;
        }
      },
      number_stations: {
        maxLength: maxLength(45)
      },
      cruise_line: {
        maxLength: maxLength(45)
      },
      flight_number: {
        required: requiredIf(function(value) {
          return false;
        }),
        isFlightValid(value) {
          if (!value) return true;
          const regex = /^[A-Z0-9]{1,3}?\d{1,5}[A-Z]?$/i;
          return regex.test(value.trim());
        },
        isValidate(value) {
          if (
            ["ARRIVAL", "DEPARTURE"].includes(
              this.flightValidationRoles.flightType
            )
          ) {
            return this.flightValidationRoles.isValidateFlightNumber;
          }
          return true;
        }
      },
      booking_reference: {
        maxLength: maxLength(25)
      },
      childSeatsCount: {
        numeric,
        integer,
        maxValue: maxValue(10)
      }
    },
    passenger: {
      firstName: {
        minLength: minLength(2),
        maxLength: maxLength(45),
        ValName
      },
      lastName: {
        minLength: minLength(2),
        maxLength: maxLength(45),
        ValName
      },
      phone: {
        minLength: minLength(10),
        maxLength: maxLength(17)
      },
      email: {
        email,
        minLength: minLength(3)
      }
    }
  },
  computed: {
    ...mapGetters(["customerOptions", "sesion", "load", "sigout", "settings"]),
    isFlightType() {
      return ["airport", "arrival", "departure"].includes(
        this.reservation.type
      );
    },
    formatDate() {
      if (this.settings && this.settings.dateFormat) {
        return this.settings.dateFormat;
      }
      return "DD-MMM-YYYY";
    },
    formatTime() {
      if (this.settings && this.settings.timeFormat) {
        return this.settings.timeFormat;
      }
      return "hh:mm A";
    },
    formatDateFlatPicker() {
      if (this.settings) {
        if (this.settings.dateFormat === "DD-MMM-YYYY") {
          return "d-M-Y";
        } else if (this.settings.dateFormat === "DD/MM/YYYY") {
          return "d/m/Y";
        }
        return "m/d/Y";
      }
      return "d-M-Y";
    },
    formatTimeFlatPicker() {
      if (this.settings) {
        const is12HourFormat = this.settings.timeFormat === "hh:mm A";
        return {
          altFormat: is12HourFormat ? "G:i K" : "H:i",
          dateFormat: is12HourFormat ? "G:i K" : "H:i",
          time_24hr: is12HourFormat ? false : true
        };
      }
      return {
        altFormat: "G:i K",
        dateFormat: "G:i K",
        time_24hr: false
      };
    }
  },
  beforeRouteLeave(to, from, next) {
    if (!this.sigout) {
      let notChanged = isEqual(this.reservation, this.reservationCopy);
      if (!notChanged && !this.saved) {
        Swal.fire({
          title: "Important",
          html:
            "The Reservation has been modified.<br> Do you want to save changes?",
          imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
          buttonsStyling: false,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          reverseButtons: true,
          cancelButtonText: "No",
          confirmButtonText: "Yes",
          confirmButtonClass: "btn btn-primary btn-small-one"
        }).then(result => {
          if (result.value) {
            this.storeReservation(to.path);
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            next();
          }
        });
      } else {
        next();
      }
    } else {
      next();
    }
  }
};
</script>
